/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface LeadMagnetClassifyInputV1 {
	/**
	 * @minLength 36
	 * @maxLength 36
	 */
	requestId: string;
	/**
	 * Optional Yandex Metrica visitor ID, stored in the request journal.
	 * @pattern ^[a-zA-Z0-9_-]{0,64}$
	 */
	metricaUserId?: string | null;
	/** @pattern ^[a-zA-Z0-9_-]{1,64}$ */
	leadMagnetId: string;
	/** @pattern ^[a-zA-Z0-9_-]{1,64}$ */
	stepId: string;
	/**
	 * @minLength 1
	 * @maxLength 16000
	 */
	prompt: string;
	/**
	 * @minLength 1
	 * @maxLength 512
	 */
	answer: string;
	/**
	 * @maxItems 8
	 * @minItems 2
	 * @uniqueItems true
	 */
	actions: string[];
}

export interface LeadMagnetClassifyResultV1 {
	action: string;
}

export interface LeadMagnetErrorV1 {
	message:
		| 'lead_magnet_invalid'
		| 'lead_magnet_answer_too_long'
		| 'lead_magnet_request_pending'
		| 'lead_magnet_request_conflict'
		| 'lead_magnet_unavailable';
}

export interface ProblemTagTypeV1 {
	/**
	 * @minLength 1
	 * @maxLength 50
	 */
	id: string;
	/**
	 * @minLength 1
	 * @maxLength 256
	 */
	title: string;
	is_visible: boolean;
	/** @min 1 */
	version: number;
}

export interface ProblemTagV1 {
	/**
	 * @minLength 1
	 * @maxLength 128
	 */
	id: string;
	/**
	 * @minLength 1
	 * @maxLength 50
	 */
	type: string;
	/**
	 * @minLength 1
	 * @maxLength 256
	 */
	title: string;
	/** @maxLength 4096 */
	hint: string;
	/** @min 1 */
	version: number;
	is_visible: boolean;
}

export interface ProblemTagCreateV1 {
	/**
	 * @minLength 1
	 * @maxLength 128
	 */
	id: string;
	/**
	 * @minLength 1
	 * @maxLength 50
	 */
	type: string;
	/**
	 * @minLength 1
	 * @maxLength 256
	 */
	title: string;
	/** @maxLength 4096 */
	hint: string;
}

export interface ProblemTagTypeCreateV1 {
	/**
	 * @minLength 1
	 * @maxLength 50
	 */
	id: string;
	/**
	 * @minLength 1
	 * @maxLength 256
	 */
	title: string;
	is_visible: boolean;
}

export interface ProblemTagUpdateV1 {
	/** @min 1 */
	expected_version: number;
	patch: {
		/**
		 * @minLength 1
		 * @maxLength 50
		 */
		type?: string;
		/**
		 * @minLength 1
		 * @maxLength 256
		 */
		title?: string;
		/** @maxLength 4096 */
		hint?: string;
	};
}

export interface ProblemTagTypeUpdateV1 {
	/** @min 1 */
	expected_version: number;
	patch: {
		/**
		 * @minLength 1
		 * @maxLength 256
		 */
		title?: string;
		is_visible?: boolean;
	};
}

export interface ProblemTagListV1 {
	items: ProblemTagV1[];
	/** @min 0 */
	total: number;
	/** @min 0 */
	offset: number;
	/** @min 1 */
	limit: number;
}

export interface ProblemTagTypeListV1 {
	items: ProblemTagTypeV1[];
	/** @min 0 */
	total: number;
	/** @min 0 */
	offset: number;
	/** @min 1 */
	limit: number;
}

export interface AIProblemTagsV1 {
	/**
	 * @minLength 1
	 * @maxLength 50
	 */
	problem_id: string;
	/** @min 0 */
	version: number;
	tags: ProblemTagV1[];
}

export interface AIProblemTagsReplaceV1 {
	/** @min 0 */
	expected_version: number;
	/**
	 * @maxItems 100
	 * @uniqueItems true
	 */
	tag_ids: string[];
}

export interface ProblemTagErrorV1 {
	message: string;
	code?: string;
}

export interface CourseLeadMagnetV1 {
	id: string;
	title: string;
	description: string;
	companyName: string;
	companyIn: string;
	courses: {
		courseId: string;
		/** @min 1 */
		languageId: number;
		label: string;
	}[];
}

/** Новый аккаунт использует email как логин (до 128 символов); существующий аккаунт входит по паролю. Без courseId регистрация доступна для самостоятельного лид-магнита. */
export interface PromoRegistrationBeginV1 {
	/** Если задан непустой ID, курс должен поддерживать промо-регистрацию. */
	courseId?: string;
	/** @format email */
	email: string;
	dataConsent: boolean;
	marketingConsent: boolean;
	consentVersion: 'promo-v1';
}

export interface PromoRegistrationChallengeV1 {
	mode: 'code' | 'password';
	challengeId?: string;
}

export interface PromoRegistrationConfirmV1 {
	challengeId: string;
	code: string;
}

export interface PromoRegistrationErrorV1 {
	message:
		| 'promo_registration_invalid'
		| 'promo_registration_code_invalid'
		| 'promo_registration_expired'
		| 'promo_registration_rate_limited'
		| 'email_already_exists';
}

export interface FreeInterview400Response {
	message: 'free_interview_invalid' | 'ai_interview_language_not_supported';
}

export interface FreeInterview409Response {
	message: 'free_interview_step_required';
}

export interface FreeInterview503Response {
	message: 'free_interview_bonus_unavailable';
}

export interface PublicFreeInterviewLandingV1 {
	/** legacy — текст по центру; standard — карточки без отчёта; ui_report — карточки с веб-отчётом; free_promotion — прежний бесплатный флоу с Telegram-отчётом; free_interview_promo — диалоговая регистрация и email-отчёт, Telegram только для рассылки; redirect — переход после интервью. */
	action?: CandidateInterviewActionV1;
	leadMagnetId?: string;
	courseId: string;
	entryInterviewId: string;
	title: string;
	description: string;
	/**
	 * Язык интервью из справочника codeLanguages.
	 * @min 1
	 */
	languageId: number;
}

export interface FreeInterviewLandingV1 {
	/**
	 * Курс, выдаваемый бессрочно после завершения интервью; включает показ отчёта на сайте.
	 * @maxLength 256
	 */
	rewardCourseId?: string;
	/**
	 * Продающий лендинг: путь сайта или абсолютный HTTP(S) URL. Используется на сайте при завершении нового промо-флоу.
	 * @maxLength 2048
	 */
	salesLandingUrl?: string;
	leadMagnetId?: string;
	enabled: boolean;
	template: 'free-interview';
	/** @maxLength 256 */
	title: string;
	/** @maxLength 4096 */
	description: string;
	entryInterviewId: string;
	canonical: boolean;
	/**
	 * Единственный язык интервью; для существующих лендингов без поля используется Go.
	 * @min 1
	 * @default 3
	 */
	languageId?: number;
	courseId?: string;
	/** Без значения сохраняется прежний бот Algocode. */
	messengerProvider?: 'telegram' | 'salebot';
	/**
	 * Список Salebot для подписки после подтверждения привязки.
	 * @format int64
	 * @min 1
	 */
	salebotListId?: number;
	/**
	 * Список Unisender для подписки при сохранении регистрации на лид-магнит, без ожидания подтверждения Telegram. Отсутствующее значение или 0 отключает подписку.
	 * @format int64
	 * @min 0
	 */
	unisenderListId?: number;
	/**
	 * Ключ атрибута клиента Salebot, в который записывается ID курса. Только для messengerProvider=salebot; без префикса client.; префикс algocode_ зарезервирован. Пустое значение отключает атрибут.
	 * @maxLength 128
	 * @pattern ^([A-Za-z][A-Za-z0-9_-]*)?$
	 */
	salebotLeadKey?: string;
	/**
	 * ID целевого курса для атрибута salebotLeadKey. Только для messengerProvider=salebot и непустого salebotLeadKey. Пустое или отсутствующее значение сохраняет ID курса регистрации.
	 * @maxLength 256
	 * @pattern ^([a-z0-9]+([_-][a-z0-9]+)*)?$
	 */
	salebotLeadVal?: string;
}

export interface SalebotErrorResponse {
	message:
		| 'salebot_unavailable'
		| 'salebot_link_conflict'
		| 'free_interview_invalid'
		| 'free_interview_step_required'
		| 'forbidden'
		| 'unauthorized';
}

export interface SalebotLinkStateV1 {
	linked: boolean;
	botUsername: string;
	courseId: string;
	deepLink?: string;
	/** @format date-time */
	expiresAt?: string;
}

export interface FreeInterviewCompletionOffersV1 {
	/** Курс из сохранённого прохождения пользователя */
	courseId: string;
	items: CommerceOfferV1[];
}

/** free_interview_promo требует languageId. Для уже авторизованного пользователя достаточно языка; targetGrade и согласия можно не передавать, сохранённые ответы не стираются. При явном согласии передаются вместе consentVersion=promo-v1, dataConsent=true и marketingConsent=true. Время явного согласия задаёт сервер; отсутствие полей не считается согласием. Опыт не запрашивается. free_promotion использует grade, experienceRange и reportMessenger=telegram. Прежняя числовая анкета допускает experienceYears с telegram/noTelegramUsername. Форматы не смешиваются. */
export interface FreeInterviewQuestionnaireV1 {
	targetGrade?:
		| 'intern'
		| 'junior'
		| 'middle'
		| 'middle_plus'
		| 'senior'
		| 'lead';
	/** @min 1 */
	languageId?: number;
	consentVersion?: 'promo-v1';
	dataConsent?: boolean;
	marketingConsent?: boolean;
	/** @format date-time */
	consentAcceptedAt?: string;
	grade?:
		| 'no_experience'
		| 'intern'
		| 'junior'
		| 'middle'
		| 'middle_plus'
		| 'senior'
		| 'lead'
		| 'other'
		| 'learning';
	experienceRange?: 'none' | '1_3' | '3_5' | '5_plus';
	reportMessenger?: 'telegram';
	/**
	 * @min 0
	 * @multipleOf 0.5
	 * @max 60
	 */
	experienceYears?: number;
	/** @maxLength 64 */
	telegram?: string;
	noTelegramUsername?: boolean;
}

export interface FreeInterviewOnboardingV1 {
	courseId: string;
	source: 'landing' | 'direct';
	/** Только utm_source, utm_medium, utm_campaign, utm_content, utm_term. */
	attribution?: Record<string, string>;
	/** free_interview_promo требует languageId. Для уже авторизованного пользователя достаточно языка; targetGrade и согласия можно не передавать, сохранённые ответы не стираются. При явном согласии передаются вместе consentVersion=promo-v1, dataConsent=true и marketingConsent=true. Время явного согласия задаёт сервер; отсутствие полей не считается согласием. Опыт не запрашивается. free_promotion использует grade, experienceRange и reportMessenger=telegram. Прежняя числовая анкета допускает experienceYears с telegram/noTelegramUsername. Форматы не смешиваются. */
	questionnaire: FreeInterviewQuestionnaireV1;
}

export interface FreeInterviewStartV1 {
	courseId: string;
	/** Необязательное подтверждение языка курса; другой язык отклоняется. Без поля сервер использует язык курса. */
	languageId?: number;
}

export interface FreeInterviewStateV1 {
	interviewId: string;
	courseId: string;
	step: 'onboarding' | 'telegram' | 'interview' | 'complete';
	bonusGranted: boolean;
	/**
	 * Целевой баланс однократного бонуса: 1000000 microUSD ($1). Начисляется только разница до него; при балансе не ниже цели сумма начисления нулевая.
	 * @format int64
	 */
	bonusAmountMicroUSD: number;
	telegramLinked: boolean;
	messengerProvider?: 'telegram' | 'salebot';
	/** free_interview_promo требует languageId. Для уже авторизованного пользователя достаточно языка; targetGrade и согласия можно не передавать, сохранённые ответы не стираются. При явном согласии передаются вместе consentVersion=promo-v1, dataConsent=true и marketingConsent=true. Время явного согласия задаёт сервер; отсутствие полей не считается согласием. Опыт не запрашивается. free_promotion использует grade, experienceRange и reportMessenger=telegram. Прежняя числовая анкета допускает experienceYears с telegram/noTelegramUsername. Форматы не смешиваются. */
	questionnaire?: FreeInterviewQuestionnaireV1;
	attemptId?: string;
	landing?: FreeInterviewLandingV1;
}

export interface CandidateSelectionConfigV1 {
	/**
	 * @minLength 1
	 * @maxLength 65536
	 */
	prompt: string;
	/**
	 * @min 30
	 * @max 50
	 */
	history_limit: number;
	/** @min 1 */
	language_id?: number;
	/** @min 1 */
	target_duration_seconds?: number;
	/**
	 * @maxItems 30
	 * @minItems 1
	 */
	slots: CandidateSelectionSlotV1[];
}

export interface CandidateSelectionSlotV1 {
	/**
	 * @minLength 1
	 * @maxLength 128
	 */
	tag_id: string;
	/**
	 * @min 1
	 * @max 86400
	 */
	time_limit_seconds: number;
}

export interface CandidateSelectionStatusV1 {
	selectionId: string;
	status: 'queued' | 'running' | 'completed' | 'error';
	attemptId?: string;
	errorCode?: string;
}

export interface CandidateSelectionErrorV1 {
	message: string;
	selectionId?: string;
}

export interface CandidateTimeAssessmentV1 {
	targetSeconds: number;
	elapsedSeconds: number;
	exceeded: boolean;
}

export interface SelectionTagV1 {
	/**
	 * @minLength 1
	 * @maxLength 128
	 */
	id: string;
	/**
	 * @minLength 1
	 * @maxLength 256
	 */
	title: string;
}

export interface SelectionTagListV1 {
	tags: SelectionTagV1[];
}

export interface AIProblemSelectionTagsV1 {
	version: number;
	tags: SelectionTagV1[];
}

export interface AIProblemSelectionTagsUpdateV1 {
	/** @min 0 */
	expected_version: number;
	/**
	 * @maxItems 100
	 * @uniqueItems true
	 */
	tag_ids: string[];
}

export interface CommerceOfferV1 {
	/** @maxLength 50 */
	id: string;
	version: number;
	title: string;
	/**
	 * Полное название покупки в платеже и чеке. При отсутствии или пустой строке формируется автоматически.
	 * @maxLength 256
	 */
	paymentTitle?: string;
	productType: string;
	courseIds: string[];
	durationDays: number;
	mode: string;
	/** @format int64 */
	creditAmountMicroUSD: number;
	priceRUB: number;
	enabled: boolean;
	providers: string[];
}

export interface CommerceCatalogV1 {
	items: CommerceOfferV1[];
}

export interface CommerceAccessV1 {
	currentMode: string;
	courses: {
		courseId: string;
		/** @format date-time */
		expiresAt: string | null;
	}[];
	periods: {
		orderId: string;
		/** @maxLength 50 */
		offerId: string;
		title: string;
		mode: string;
		/** @format date-time */
		startsAt: string;
		/** @format date-time */
		expiresAt: string;
	}[];
}

export interface CommerceBalanceV1 {
	available: boolean;
	/** @format int64 */
	balanceMicroUSD: number;
	/** @format int64 */
	pendingCreditsMicroUSD: number;
}

export interface CandidateInterviewAuthoringItemV1 {
	/**
	 * @minLength 1
	 * @maxLength 50
	 */
	problem_id: string;
	/**
	 * @min 1
	 * @max 86400
	 */
	time_limit_seconds: number;
}

export interface CandidateInterviewAuthoringSummaryV1 {
	id: string;
	title: string;
	type: 'welcome' | 'regular';
	is_free: boolean;
	is_visible: boolean;
	permission_level: 'public' | 'regular' | 'advanced';
	version: number;
	total_time_seconds: number;
	item_count: number;
}

export interface CandidateInterviewAuthoringDefinitionV1 {
	/** legacy — текст по центру; standard — карточки без отчёта; ui_report — карточки с веб-отчётом; free_promotion — прежний бесплатный флоу с Telegram-отчётом; free_interview_promo — диалоговая регистрация и email-отчёт, Telegram только для рассылки; redirect — переход после интервью. */
	action?: CandidateInterviewActionV1;
	/**
	 * Только для redirect: путь сайта или абсолютный HTTP(S) URL после завершения.
	 * @maxLength 2048
	 */
	redirectUrl?: string;
	/** Только для redirect: режим отчёта. По умолчанию none. */
	redirectReport?: CandidateInterviewRedirectReportV1;
	selection_mode?: 'fixed' | 'llm';
	selection_config?: CandidateSelectionConfigV1;
	id: string;
	title: string;
	type: 'welcome' | 'regular';
	is_free: boolean;
	is_visible: boolean;
	permission_level: 'public' | 'regular' | 'advanced';
	version: number;
	total_time_seconds: number;
	items: CandidateInterviewAuthoringItemV1[];
}

export interface CandidateInterviewAuthoringListV1 {
	total: number;
	offset: number;
	limit: number;
	items: CandidateInterviewAuthoringSummaryV1[];
}

export interface CandidateInterviewAuthoringCandidateV1 {
	/** legacy — текст по центру; standard — карточки без отчёта; ui_report — карточки с веб-отчётом; free_promotion — прежний бесплатный флоу с Telegram-отчётом; free_interview_promo — диалоговая регистрация и email-отчёт, Telegram только для рассылки; redirect — переход после интервью. */
	action?: CandidateInterviewActionV1;
	/**
	 * Только для redirect: путь сайта или абсолютный HTTP(S) URL после завершения.
	 * @maxLength 2048
	 */
	redirectUrl?: string;
	/** Только для redirect: режим отчёта. По умолчанию none. */
	redirectReport?: CandidateInterviewRedirectReportV1;
	selection_mode?: 'fixed' | 'llm';
	selection_config?: CandidateSelectionConfigV1;
	/**
	 * @minLength 1
	 * @maxLength 50
	 * @pattern ^[a-z0-9]+(?:[_-][a-z0-9]+)*$
	 */
	id: string;
	/**
	 * @minLength 1
	 * @maxLength 255
	 */
	title: string;
	type: 'welcome' | 'regular';
	is_free: boolean;
	permission_level: 'public' | 'regular' | 'advanced';
	/**
	 * @maxItems 30
	 * @minItems 0
	 */
	items?: CandidateInterviewAuthoringItemV1[];
}

export interface CandidateInterviewAuthoringCreateV1 {
	interview: CandidateInterviewAuthoringCandidateV1;
}

export interface CandidateInterviewAuthoringChangesV1 {
	/** legacy — текст по центру; standard — карточки без отчёта; ui_report — карточки с веб-отчётом; free_promotion — прежний бесплатный флоу с Telegram-отчётом; free_interview_promo — диалоговая регистрация и email-отчёт, Telegram только для рассылки; redirect — переход после интервью. */
	action?: CandidateInterviewActionV1;
	/**
	 * Только для redirect: путь сайта или абсолютный HTTP(S) URL после завершения.
	 * @maxLength 2048
	 */
	redirectUrl?: string;
	/** Только для redirect: режим отчёта. По умолчанию none. */
	redirectReport?: CandidateInterviewRedirectReportV1;
	selection_mode?: 'fixed' | 'llm';
	selection_config?: CandidateSelectionConfigV1;
	/**
	 * @minLength 1
	 * @maxLength 255
	 */
	title?: string;
	is_free?: boolean;
	is_visible?: boolean;
	permission_level?: 'public' | 'regular' | 'advanced';
	/**
	 * @maxItems 30
	 * @minItems 0
	 */
	items?: CandidateInterviewAuthoringItemV1[];
}

export interface CandidateInterviewAuthoringUpdateV1 {
	/** @min 1 */
	expected_version: number;
	changes: CandidateInterviewAuthoringChangesV1;
}

export interface CandidateInterviewReportCriterionConfigV1 {
	key: string;
	title: string;
	/** @format double */
	max_score: number;
	/** @format double */
	score_step: number;
	rubric: string;
}

export interface CandidateInterviewReportGradeConfigV1 {
	/** @format double */
	min_score: number;
	code: string;
	title: string;
}

export interface CandidateInterviewReportCompletionRuleV1 {
	require_all_solved: boolean;
	failure_label: string;
}

export interface CandidateInterviewReportConfigV1 {
	prompt: string;
	criteria: CandidateInterviewReportCriterionConfigV1[];
	grade_scale: CandidateInterviewReportGradeConfigV1[];
	completion_rule: CandidateInterviewReportCompletionRuleV1;
}

export interface CandidateInterviewReportConfigEnvelopeV1 {
	version: number;
	config: CandidateInterviewReportConfigV1 | null;
}

export interface CandidateInterviewReportConfigUpdateV1 {
	/** @min 0 */
	expected_version: number;
	config: CandidateInterviewReportConfigV1;
}

export interface CandidateInterviewReportGradeV1 {
	code: string;
	title: string;
}

export interface CandidateInterviewReportTaskV1 {
	position: number;
	problemId: string;
	title: string;
	status: string;
	solved: boolean;
	dialogId?: string;
	durationSeconds?: number;
}

export interface CandidateInterviewReportCriterionV1 {
	key: string;
	title: string;
	/** @format double */
	score: number;
	/** @format double */
	maxScore: number;
	explanationMarkdown: string;
}

export interface CandidateInterviewReportV1 {
	timeAssessment?: CandidateTimeAssessmentV1;
	model?: string;
	configVersion: number;
	summaryMarkdown: string;
	/** @format double */
	totalScore: number;
	/** @format double */
	maxScore: number;
	outcome: 'graded' | 'no_hire';
	outcomeLabel: string;
	grade?: CandidateInterviewReportGradeV1;
	criteria: CandidateInterviewReportCriterionV1[];
	tasks: CandidateInterviewReportTaskV1[];
	/** @format date-time */
	generatedAt: string;
}

export interface CandidateInterviewCourseRewardV1 {
	courseId: string;
	/** Подтверждённое действующее право, выданное за эту попытку. */
	granted: boolean;
	/**
	 * NULL означает бессрочное право.
	 * @format date-time
	 */
	expiresAt: string | null;
}

export interface CandidateInterviewReportEnvelopeV1 {
	courseReward?: CandidateInterviewCourseRewardV1;
	/** Продающий лендинг курса из сохранённого участия */
	salesLandingUrl?: string;
	delivery?: 'none' | 'ui' | 'telegram' | 'email';
	/** Email получателя отчёта для своей попытки */
	email?: string;
	emailQueued?: boolean;
	telegramLinked?: boolean;
	messengerProvider?: 'telegram' | 'salebot';
	telegramSent?: boolean;
	timeAssessment?: CandidateTimeAssessmentV1;
	attemptId: string;
	status: 'unavailable' | 'pending' | 'ready' | 'error';
	tasks: CandidateInterviewReportTaskV1[];
	report?: CandidateInterviewReportV1;
	errorCode?: string;
}

export interface CandidateInterviewHistoryItemV1 {
	/** legacy — текст по центру; standard — карточки без отчёта; ui_report — карточки с веб-отчётом; free_promotion — прежний бесплатный флоу с Telegram-отчётом; free_interview_promo — диалоговая регистрация и email-отчёт, Telegram только для рассылки; redirect — переход после интервью. */
	action?: CandidateInterviewActionV1;
	/**
	 * Только для redirect: путь сайта или абсолютный HTTP(S) URL после завершения.
	 * @maxLength 2048
	 */
	redirectUrl?: string;
	/** Только для redirect: режим отчёта. По умолчанию none. */
	redirectReport?: CandidateInterviewRedirectReportV1;
	id: string;
	interviewId: string;
	status: string;
	/** @format date-time */
	startedAt: string;
	/** @format date-time */
	finishedAt?: string;
	reason: string;
	reportStatus: 'unavailable' | 'pending' | 'ready' | 'error';
	outcomeLabel?: string;
	grade?: CandidateInterviewReportGradeV1;
}

export interface CandidateInterviewHistoryV1 {
	total: number;
	items: CandidateInterviewHistoryItemV1[];
}

export interface CandidateInterviewItemReplayV1 {
	messages: AIVisibleMessageV1[];
	attemptId: string;
	interviewId: string;
	item: CandidateInterviewAttemptItemV1;
	problem?: GetAIProblemResponseV1;
	dialog?: GetAIDialogResponseV1;
}

export interface InternalCandidateInterviewResultV1 {
	report?: CandidateInterviewReportEnvelopeV1;
	interview_id: string;
	title: string;
	user_login: string;
	attempt_id: string;
	status: string;
	/** @format date-time */
	started_at: string;
	/** @format date-time */
	deadline_at: string;
	/** @format date-time */
	finished_at?: string;
	reason: string;
	items: InternalCandidateInterviewResultItemV1[];
}

export interface InternalCandidateInterviewResultItemV1 {
	position: number;
	ai_problem_id: string;
	title: string;
	status: string;
	time_limit_seconds: number;
	/**
	 * Начало таймера позиции
	 * @format date-time
	 */
	opened_at?: string;
	/** @format date-time */
	first_message_at?: string;
	/** @format date-time */
	first_response_at?: string;
	/** @format date-time */
	deadline_at?: string;
	/** @format date-time */
	finished_at?: string;
	/** Текущее условие и конфигурация задач; не исторический снимок. */
	problem: GetAdminAIProblemResponseV1;
	dialog?: InternalAIDialogResultV1;
}

/** legacy — текст по центру; standard — карточки без отчёта; ui_report — карточки с веб-отчётом; free_promotion — прежний бесплатный флоу с Telegram-отчётом; free_interview_promo — диалоговая регистрация и email-отчёт, Telegram только для рассылки; redirect — переход после интервью. */
export enum CandidateInterviewActionV1 {
	Legacy = 'legacy',
	Standard = 'standard',
	UiReport = 'ui_report',
	FreePromotion = 'free_promotion',
	FreeInterviewPromo = 'free_interview_promo',
	Redirect = 'redirect',
}

/** Только для redirect: режим отчёта. По умолчанию none. */
export enum CandidateInterviewRedirectReportV1 {
	None = 'none',
	Ui = 'ui',
	Telegram = 'telegram',
}

export interface CandidateInterviewV1 {
	/** legacy — текст по центру; standard — карточки без отчёта; ui_report — карточки с веб-отчётом; free_promotion — прежний бесплатный флоу с Telegram-отчётом; free_interview_promo — диалоговая регистрация и email-отчёт, Telegram только для рассылки; redirect — переход после интервью. */
	action?: CandidateInterviewActionV1;
	/**
	 * Только для redirect: путь сайта или абсолютный HTTP(S) URL после завершения.
	 * @maxLength 2048
	 */
	redirectUrl?: string;
	/** Только для redirect: режим отчёта. По умолчанию none. */
	redirectReport?: CandidateInterviewRedirectReportV1;
	selectionMode?: 'fixed' | 'llm';
	languageId?: number;
	targetDurationSeconds?: number;
	selection?: CandidateSelectionStatusV1;
	id: string;
	title: string;
	type: 'welcome' | 'regular';
	totalSeconds: number;
	itemCount: number;
	canStart: boolean;
	attempt?: CandidateInterviewAttemptV1;
}

export interface CandidateInterviewAttemptItemV1 {
	position: number;
	problemId: string;
	timeLimitSeconds: number;
	status: string;
	dialogId?: string;
	/** @format date-time */
	startedAt?: string;
	/** @format date-time */
	deadlineAt?: string;
	/** @format date-time */
	finishedAt?: string;
}

export interface CandidateInterviewAttemptV1 {
	courseReward?: CandidateInterviewCourseRewardV1;
	/** Продающий лендинг курса из сохранённого участия */
	salesLandingUrl?: string;
	/** legacy — текст по центру; standard — карточки без отчёта; ui_report — карточки с веб-отчётом; free_promotion — прежний бесплатный флоу с Telegram-отчётом; free_interview_promo — диалоговая регистрация и email-отчёт, Telegram только для рассылки; redirect — переход после интервью. */
	action?: CandidateInterviewActionV1;
	/**
	 * Только для redirect: путь сайта или абсолютный HTTP(S) URL после завершения.
	 * @maxLength 2048
	 */
	redirectUrl?: string;
	/** Только для redirect: режим отчёта. По умолчанию none. */
	redirectReport?: CandidateInterviewRedirectReportV1;
	id: string;
	interviewId: string;
	status: string;
	currentPosition: number;
	version: number;
	/**
	 * Saved target limit, independent of the technical deadline.
	 * @min 1
	 */
	targetDurationSeconds?: number;
	/** @format date-time */
	startedAt: string;
	/** @format date-time */
	deadlineAt: string;
	/** @format date-time */
	finishedAt?: string;
	reason: string;
	/** @format date-time */
	serverNow: string;
	items: CandidateInterviewAttemptItemV1[];
	problem?: GetAIProblemResponseV1;
	dialog?: GetAIDialogResponseV1;
}

export interface StartCandidateInterviewV1 {
	/**
	 * @minLength 1
	 * @maxLength 128
	 */
	requestId?: string;
	languageId?: number;
}

export interface AdvanceCandidateInterviewV1 {
	position: number;
	version: number;
	skip: boolean;
}

export enum InternalCourseLessonTypeV1 {
	AlgoProblem = 'algo_problem',
	TheoryLesson = 'theory_lesson',
	InterviewSimulator = 'interview_simulator',
	AiProblem = 'ai_problem',
	VideoLesson = 'video_lesson',
	CandidateInterview = 'candidate_interview',
}

export interface InternalCourseLessonRefV1 {
	/**
	 * @minLength 1
	 * @maxLength 256
	 */
	lesson_id: string;
	lesson_type: InternalCourseLessonTypeV1;
}

export interface InternalCourseSubtopicV1 {
	/**
	 * @minLength 1
	 * @maxLength 256
	 */
	name: string;
	/** @maxLength 4096 */
	summary: string;
	lessons: InternalCourseLessonRefV1[];
}

export interface InternalCourseTopicV1 {
	/**
	 * @minLength 1
	 * @maxLength 256
	 */
	name: string;
	subtopics: InternalCourseSubtopicV1[];
}

export interface InternalCoursePlanV1 {
	/**
	 * @minLength 1
	 * @maxLength 256
	 */
	name: string;
	/** @maxLength 4096 */
	description: string;
	/** @maxLength 1024 */
	image: string;
	/**
	 * @min 0
	 * @max 3
	 */
	difficulty: number;
	topics: InternalCourseTopicV1[];
}

export interface InternalCourseCandidateV1 {
	free_interview_landing?: FreeInterviewLandingV1;
	/**
	 * @minLength 1
	 * @maxLength 256
	 * @pattern ^[a-z0-9]+(?:[_-][a-z0-9]+)*$
	 */
	id: string;
	/**
	 * @minLength 1
	 * @maxLength 256
	 */
	name: string;
	/** @maxLength 4096 */
	description: string;
	/** @maxLength 1024 */
	image: string;
	/**
	 * @min 0
	 * @max 3
	 */
	difficulty: number;
	is_public: boolean;
	permission_level: PermissionLevelV1;
	plans: InternalCoursePlanV1[];
}

export interface InternalCourseV1 {
	free_interview_landing?: FreeInterviewLandingV1;
	/**
	 * @minLength 1
	 * @maxLength 256
	 * @pattern ^[a-z0-9]+(?:[_-][a-z0-9]+)*$
	 */
	id: string;
	/**
	 * @minLength 1
	 * @maxLength 256
	 */
	name: string;
	/** @maxLength 4096 */
	description: string;
	/** @maxLength 1024 */
	image: string;
	/**
	 * @min 0
	 * @max 3
	 */
	difficulty: number;
	is_public: boolean;
	permission_level: PermissionLevelV1;
	plans: InternalCoursePlanV1[];
	/** @min 1 */
	version: number;
	is_visible: boolean;
}

export interface InternalCourseSummaryV1 {
	id: string;
	name: string;
	/**
	 * @min 0
	 * @max 3
	 */
	difficulty: number;
	/** @min 1 */
	version: number;
	is_visible: boolean;
	is_public: boolean;
	permission_level: PermissionLevelV1;
	/** @min 0 */
	plan_count: number;
	/** @min 0 */
	lesson_count: number;
}

export interface InternalCourseListResponseV1 {
	items: InternalCourseSummaryV1[];
	/** @min 0 */
	offset: number;
	/**
	 * @min 1
	 * @max 100
	 */
	limit: number;
	/** @min 0 */
	total: number;
}

export interface InternalCourseCreateRequestV1 {
	course: InternalCourseCandidateV1;
}

export interface InternalCoursePatchV1 {
	free_interview_landing?: FreeInterviewLandingV1;
	/**
	 * @minLength 1
	 * @maxLength 256
	 */
	name?: string;
	/** @maxLength 4096 */
	description?: string;
	/** @maxLength 1024 */
	image?: string;
	/**
	 * @min 0
	 * @max 3
	 */
	difficulty?: number;
	is_public?: boolean;
	permission_level?: PermissionLevelV1;
	plans?: InternalCoursePlanV1[];
	is_visible?: boolean;
}

export interface InternalCourseConfirmationAnswerV1 {
	/** @minLength 1 */
	token: string;
	choice: 'publish' | 'hide' | 'cancel';
}

export interface InternalCourseUpdateRequestV1 {
	/** @min 1 */
	expected_version: number;
	changes: InternalCoursePatchV1;
	confirmation?: InternalCourseConfirmationAnswerV1;
}

export interface InternalCourseUpdateConfirmationV1 {
	/** @minLength 1 */
	token: string;
	message: string;
	/**
	 * @maxItems 2
	 * @minItems 2
	 */
	choices: ('publish' | 'hide' | 'cancel')[];
}

export interface InternalCourseUpdatedResultV1 {
	status: 'updated';
	course: InternalCourseV1;
}

export interface InternalCourseConfirmationRequiredResultV1 {
	status: 'confirmation_required';
	confirmation: InternalCourseUpdateConfirmationV1;
}

export interface InternalCourseCancelledResultV1 {
	status: 'cancelled';
}

export type InternalCourseUpdateResultV1 =
	| InternalCourseUpdatedResultV1
	| InternalCourseConfirmationRequiredResultV1
	| InternalCourseCancelledResultV1;

export interface InternalCourseFieldErrorV1 {
	field: string;
	code:
		| 'required'
		| 'invalid_format'
		| 'invalid_value'
		| 'too_long'
		| 'duplicate_lesson'
		| 'lesson_not_found'
		| 'lesson_type_mismatch'
		| 'course_plan_empty';
	message?: string;
}

export interface InternalCourseErrorV1 {
	code:
		| 'invalid_request'
		| 'course_not_found'
		| 'course_already_exists'
		| 'version_conflict'
		| 'validation_failed'
		| 'confirmation_invalid'
		| 'confirmation_expired';
	message: string;
	request_id: string;
	field_errors?: InternalCourseFieldErrorV1[];
	/** @min 1 */
	current_version?: number;
}

export interface InternalRoadmapGroupV1 {
	/**
	 * @minLength 1
	 * @maxLength 256
	 */
	name: string;
	is_visible: boolean;
	topics: InternalRoadmapTopicV1[];
}

export interface InternalRoadmapTopicV1 {
	/**
	 * @minLength 1
	 * @maxLength 256
	 */
	name: string;
	/**
	 * @minLength 1
	 * @maxLength 256
	 */
	slug: string;
	/** @maxLength 4096 */
	description: string;
	/** @maxLength 1024 */
	image: string;
	type: 'course' | 'exerciser';
}

export interface InternalRoadmapCandidateV1 {
	/**
	 * @minLength 1
	 * @maxLength 128
	 * @pattern ^[a-z0-9]+(?:[_-][a-z0-9]+)*$
	 */
	id: string;
	/**
	 * @minLength 1
	 * @maxLength 50
	 */
	name: string;
	/** @maxLength 255 */
	description: string;
	/** @maxLength 512 */
	image: string;
	/** @maxLength 10 */
	color: string;
	is_public: boolean;
	permission_level: PermissionLevelV1;
	groups: InternalRoadmapGroupV1[];
}

export interface InternalRoadmapV1 {
	/**
	 * @minLength 1
	 * @maxLength 128
	 * @pattern ^[a-z0-9]+(?:[_-][a-z0-9]+)*$
	 */
	id: string;
	/**
	 * @minLength 1
	 * @maxLength 50
	 */
	name: string;
	/** @maxLength 255 */
	description: string;
	/** @maxLength 512 */
	image: string;
	/** @maxLength 10 */
	color: string;
	is_public: boolean;
	permission_level: PermissionLevelV1;
	groups: InternalRoadmapGroupV1[];
	/** @min 1 */
	version: number;
	is_visible: boolean;
}

export interface InternalRoadmapSummaryV1 {
	id: string;
	name: string;
	/** @maxLength 10 */
	color: string;
	/** @min 1 */
	version: number;
	is_visible: boolean;
	is_public: boolean;
	permission_level: PermissionLevelV1;
	/** @min 0 */
	group_count: number;
	/** @min 0 */
	topic_count: number;
}

export interface InternalRoadmapListResponseV1 {
	items: InternalRoadmapSummaryV1[];
	/** @min 0 */
	offset: number;
	/**
	 * @min 1
	 * @max 100
	 */
	limit: number;
	/** @min 0 */
	total: number;
}

export interface InternalRoadmapCreateRequestV1 {
	roadmap: InternalRoadmapCandidateV1;
}

export interface InternalRoadmapPatchV1 {
	/**
	 * @minLength 1
	 * @maxLength 50
	 */
	name?: string;
	/** @maxLength 255 */
	description?: string;
	/** @maxLength 512 */
	image?: string;
	/** @maxLength 10 */
	color?: string;
	is_public?: boolean;
	permission_level?: PermissionLevelV1;
	groups?: InternalRoadmapGroupV1[];
	is_visible?: boolean;
}

export interface InternalRoadmapConfirmationAnswerV1 {
	/** @minLength 1 */
	token: string;
	choice: 'publish' | 'hide' | 'cancel';
}

export interface InternalRoadmapUpdateRequestV1 {
	/** @min 1 */
	expected_version: number;
	changes: InternalRoadmapPatchV1;
	confirmation?: InternalRoadmapConfirmationAnswerV1;
}

export interface InternalRoadmapUpdateConfirmationV1 {
	/** @minLength 1 */
	token: string;
	message: string;
	/**
	 * @maxItems 2
	 * @minItems 2
	 */
	choices: ('publish' | 'hide' | 'cancel')[];
}

export interface InternalRoadmapUpdatedResultV1 {
	status: 'updated';
	roadmap: InternalRoadmapV1;
}

export interface InternalRoadmapConfirmationRequiredResultV1 {
	status: 'confirmation_required';
	confirmation: InternalRoadmapUpdateConfirmationV1;
}

export interface InternalRoadmapCancelledResultV1 {
	status: 'cancelled';
}

export type InternalRoadmapUpdateResultV1 =
	| InternalRoadmapUpdatedResultV1
	| InternalRoadmapConfirmationRequiredResultV1
	| InternalRoadmapCancelledResultV1;

export interface InternalRoadmapFieldErrorV1 {
	field: string;
	code:
		| 'required'
		| 'invalid_format'
		| 'invalid_value'
		| 'too_long'
		| 'course_not_found';
	message?: string;
}

export interface InternalRoadmapErrorV1 {
	code:
		| 'invalid_request'
		| 'roadmap_not_found'
		| 'roadmap_already_exists'
		| 'version_conflict'
		| 'validation_failed'
		| 'confirmation_invalid'
		| 'confirmation_expired';
	message: string;
	request_id: string;
	field_errors?: InternalRoadmapFieldErrorV1[];
	/** @min 1 */
	current_version?: number;
}

export interface SubscriptionChangedResponseV1 {
	message: 'subscription_changed';
}

export interface SurveyShowWhenV1 {
	questionId: string;
	optionId: string;
}

export enum SurveyQuestionTypeV1 {
	SingleChoice = 'single_choice',
	MultiChoice = 'multi_choice',
	FreeText = 'free_text',
}

export enum SurveyNotificationTypeV1 {
	SurveyNotificationTypeV1None = 'none',
	SurveyNotificationTypeV1Onboarding = 'onboarding',
	SurveyNotificationTypeV1ManagerLead = 'manager_lead',
}

export interface SurveyOptionV1 {
	/** @default false */
	requiresText?: boolean;
	id: string;
	label: string;
}

export interface SurveyQuestionV1 {
	showWhen?: SurveyShowWhenV1;
	id: string;
	type: SurveyQuestionTypeV1;
	title: string;
	options?: SurveyOptionV1[];
}

export interface SurveyV1 {
	id: string;
	title: string;
	isPublic: boolean;
	notificationType: SurveyNotificationTypeV1;
	questions: SurveyQuestionV1[];
}

export interface CreateSurveyRequestV1 {
	id: string;
	title: string;
	isPublic: boolean;
	notificationType: SurveyNotificationTypeV1;
	questions: SurveyQuestionV1[];
}

export interface UpdateSurveyRequestV1 {
	title: string;
	isPublic: boolean;
	notificationType: SurveyNotificationTypeV1;
	questions: SurveyQuestionV1[];
}

export interface SurveyAnswerInputV1 {
	questionId: string;
	optionIds?: string[];
	/** At most 1000 Unicode code points after trimming whitespace. */
	textValue?: string;
}

export interface SubmitSurveyResponseRequestV1 {
	answers: SurveyAnswerInputV1[];
}

export interface SurveyOptionCountV1 {
	optionId: string;
	count: number;
}

export interface SurveyQuestionDistributionV1 {
	questionId: string;
	type: SurveyQuestionTypeV1;
	respondentCount: number;
	options?: SurveyOptionCountV1[];
}

export interface SurveyDistributionV1 {
	id: string;
	questions: SurveyQuestionDistributionV1[];
}

export interface UserSurveyAnswerV1 {
	questionId: string;
	optionIds?: string[];
	textValue?: string;
}

export interface UserSurveyResponseV1 {
	formId: string;
	answers: UserSurveyAnswerV1[];
}

export interface UserSurveysV1 {
	responses: UserSurveyResponseV1[];
}

export enum CRMDialogStatusV1 {
	Pending = 'pending',
	InProgress = 'in_progress',
	Paused = 'paused',
	BlackList = 'black_list',
}

/**
 * Канонический грейд клиента. До заполнения onboarding имеет значение unknown;
 * затем заполняется из анкеты и может быть изменён менеджером.
 */
export enum CRMClientGradeV1 {
	Unknown = 'unknown',
	Student = 'student',
	Vkatun = 'vkatun',
	Junior = 'junior',
	Middle = 'middle',
	Senior = 'senior',
	Lead = 'lead',
	Cto = 'cto',
	Other = 'other',
}

/** Стабильный optionId направления из onboarding-формы. */
export enum CRMClientOccupationV1 {
	CRMClientOccupationV1Backend = 'backend',
	CRMClientOccupationV1Frontend = 'frontend',
	CRMClientOccupationV1Mobile = 'mobile',
	CRMClientOccupationV1ML = 'ml',
	CRMClientOccupationV1Data = 'data',
	CRMClientOccupationV1QA = 'qa',
	CRMClientOccupationV1DevOps = 'devops',
	CRMClientOccupationV1Other = 'other',
}

/** Стабильный optionId основного языка из onboarding-формы. */
export enum CRMPrimaryLanguageV1 {
	CRMPrimaryLanguageV1Python = 'python',
	CRMPrimaryLanguageV1JavaScript = 'javascript',
	CRMPrimaryLanguageV1TypeScript = 'typescript',
	CRMPrimaryLanguageV1Go = 'go',
	CRMPrimaryLanguageV1Java = 'java',
	CRMPrimaryLanguageV1Cpp = 'cpp',
	CRMPrimaryLanguageV1CSharp = 'csharp',
	CRMPrimaryLanguageV1Kotlin = 'kotlin',
	CRMPrimaryLanguageV1Swift = 'swift',
	CRMPrimaryLanguageV1Other = 'other',
}

/**
 * Идентификатор из GET /v1/crm/stages.
 * @minLength 1
 * @maxLength 32
 */
export type CRMStageV1 = string;

export interface CRMStageCatalogItemV1 {
	/** Идентификатор из GET /v1/crm/stages. */
	id: CRMStageV1;
	title: string;
	sortOrder: number;
}

export interface CRMStagesResponseV1 {
	items: CRMStageCatalogItemV1[];
}

export enum CRMEntrySourceV1 {
	CRMEntrySourceV1Segment = 'segment',
	CRMEntrySourceV1HotForm = 'hot_form',
	CRMEntrySourceV1IntentPool = 'intent_pool',
	CRMEntrySourceV1Manual = 'manual',
}

export enum CRMClientSortV1 {
	CRMClientSortV1CurrentTaskDeadline = 'current_task_deadline',
	CRMClientSortV1StageChangedAt = 'stage_changed_at',
	CRMClientSortV1LastContactAt = 'last_contact_at',
	CRMClientSortV1CreatedAt = 'created_at',
}

export enum CRMSortOrderV1 {
	CRMSortOrderV1Asc = 'asc',
	CRMSortOrderV1Desc = 'desc',
}

export enum CRMActivityStatusV1 {
	NotStarted = 'not_started',
	OnTrack = 'on_track',
	GoodTrack = 'good_track',
	BestTrack = 'best_track',
	Inactive = 'inactive',
}

export enum CRMRiskStatusV1 {
	Low = 'low',
	Medium = 'medium',
	High = 'high',
	Critical = 'critical',
}

export enum CRMCustomerStatusV1 {
	NeverPaid = 'never_paid',
	New = 'new',
	Regular = 'regular',
	Loyal = 'loyal',
	CriticalLeft = 'critical_left',
	Left = 'left',
}

export interface CRMClientV1 {
	id: string;
	/** users.id in uppercase hex form */
	userId: string;
	userLogin: string;
	email: string;
	/**
	 * Имя клиента, указанное менеджером или администратором.
	 * @maxLength 255
	 */
	name?: string;
	/**
	 * Telegram для личного общения, вручную указанный менеджером или администратором.
	 * @maxLength 32
	 */
	personalTelegram?: string;
	/** Telegram username, привязанный пользователем к аккаунту. */
	linkedTelegramUsername?: string;
	managerLogin?: string;
	managerName?: string;
	dialogStatus: CRMDialogStatusV1;
	/**
	 * Канонический грейд клиента. До заполнения onboarding имеет значение unknown;
	 * затем заполняется из анкеты и может быть изменён менеджером.
	 */
	clientGrade: CRMClientGradeV1;
	/** Стабильный optionId направления из onboarding-формы. */
	occupation?: CRMClientOccupationV1;
	/** Стабильный optionId основного языка из onboarding-формы. */
	primaryLanguage?: CRMPrimaryLanguageV1;
	/** Контакт в том виде, в котором клиент указал его в onboarding. */
	onboardingContact?: string;
	/** Готовый текст срока выхода на собеседования из onboarding. */
	interviewTiming?: string;
	/** Готовые строки тем интересов из onboarding. */
	interestTopics: string[];
	/** Готовый текст времени на обучение из onboarding. */
	studyTime?: string;
	/** Готовый текст источника из onboarding. */
	acquisitionSource?: string;
	/** Совпадает ли текущий профиль с автоматическим сегментом продаж. */
	salesEligible: boolean;
	/** Идентификатор из GET /v1/crm/stages. */
	stage: CRMStageV1;
	/** @format date-time */
	stageChangedAt: string;
	entrySource?: CRMEntrySourceV1;
	/**
	 * Weighted score from unique first theory reads and unique first accepted problems in the rolling 30-day window.
	 * @format double
	 */
	activityScore: number;
	/**
	 * Unweighted score from the same unique events during the last 7 days.
	 * @format double
	 */
	activityScore7d: number;
	/** Full 24-hour days since the last first theory read or submission; null when there has never been an activity event. */
	silentDays: number | null;
	activityStatus: CRMActivityStatusV1;
	/** Full days until the latest subscription expiration; null when the expiration date is unknown. May be negative for an expired subscription. */
	daysToSubscriptionEnd: number | null;
	riskStatus: CRMRiskStatusV1;
	/**
	 * Full paid subscription days in the trailing 100-day window. For inactive subscriptions the window ends at the subscription end.
	 * @min 0
	 * @max 100
	 */
	paidDays100d: number;
	/**
	 * Full days since the subscription ended; null while it is active or its end is unknown.
	 * @min 0
	 */
	daysWithoutSubscription: number | null;
	customerStatus: CRMCustomerStatusV1;
	clientRequest?: string;
	clientRequestStatus?: string;
	managerActions?: string;
	note?: string;
	/**
	 * Дата последней коммуникации; отсутствует, если история коммуникаций пуста.
	 * @format date-time
	 */
	lastContactAt?: string;
	subscriptionActive: boolean;
	/** @format date-time */
	subscriptionExpirationDate?: string;
	/**
	 * Ближайший дедлайн активной manager task; отсутствует, если активных tasks нет.
	 * @format date-time
	 */
	nearestTaskDeadlineAt?: string;
	/** @format date-time */
	createdAt: string;
}

export interface CRMClientListResponseV1 {
	total: number;
	items: CRMClientV1[];
}

export interface CRMClientDetailsResponseV1 {
	client: CRMClientV1;
	surveys: UserSurveysV1;
	/** Отсутствует, если менеджер ещё не получил эту информацию. */
	interviewPreparationStatus?: CRMInterviewPreparationStatusV1;
	/**
	 * Когда менеджер получил или повторно подтвердил статус подготовки.
	 * @format date-time
	 */
	interviewPreparationReceivedAt?: string;
	/**
	 * Темы прогрева, которыми управляет менеджер. Отсутствующая явная
	 * настройка отображается как enabled=false и explicitlyConfigured=false.
	 */
	warmingTopics: CRMClientInterestTopicV1[];
	history: CRMHistoryEventV1[];
	/** Текущее резюме; отсутствует, пока файл не загружен. */
	resume?: CRMResumeV1;
}

export interface CRMResumeV1 {
	/** Original uploaded file name. */
	fileName: string;
	contentType: string;
	/** @format int64 */
	size: number;
	/** @format date-time */
	uploadedAt: string;
	/** Авторизованная backend-ручка скачивания текущего резюме. */
	downloadUrl: string;
}

export interface CRMHistoryEventV1 {
	id: string;
	authorUserId: string;
	authorLogin: string;
	authorName?: string;
	summary: string;
	taskId?: string;
	taskTitle?: string;
	/** @format date-time */
	createdAt: string;
}

export enum CRMInterviewPreparationStatusV1 {
	CRMInterviewPreparationStatusV1Preparing = 'preparing',
	CRMInterviewPreparationStatusV1NotPreparing = 'not_preparing',
}

export interface CRMInterestTopicV1 {
	/** Стабильный код темы для API и будущих правил автоматизации. */
	id: string;
	/** Отображаемое название. */
	title: string;
	/** Категория темы, например interview, algorithms или learning. */
	category: string;
}

export interface CRMInterestTopicsResponseV1 {
	items: CRMInterestTopicV1[];
}

export interface CRMClientInterestTopicV1 {
	topic: CRMInterestTopicV1;
	/**
	 * Эффективное состояние переключателя в CRM. Для автоматической
	 * доставки также нужны активная продуктовая подписка и менеджер.
	 */
	enabled: boolean;
	/** true, если менеджер уже явно включал или отключал топик. */
	explicitlyConfigured: boolean;
	/**
	 * Когда менеджер установил или повторно подтвердил состояние. Отсутствует,
	 * пока топик явно не настроен.
	 * @format date-time
	 */
	receivedAt?: string;
}

export interface CRMClientInterestTopicInputV1 {
	topicId: string;
	enabled: boolean;
}

export interface ReplaceCRMClientInterestTopicsRequestV1 {
	/**
	 * Полный набор явных настроек. topicId не может повторяться и должен
	 * ссылаться на активный топик.
	 * @maxItems 100
	 */
	topics: CRMClientInterestTopicInputV1[];
}

export interface CRMClientInterestTopicsResponseV1 {
	items: CRMClientInterestTopicV1[];
}

export enum CRMTaskTypeV1 {
	CRMTaskTypeV1FirstContactMessage = 'first_contact_message',
	CRMTaskTypeV1ProgressReportMessage = 'progress_report_message',
	CRMTaskTypeV1ReactivationMessage = 'reactivation_message',
	CRMTaskTypeV1Manual = 'manual',
}

export enum CRMTaskStatusV1 {
	CRMTaskStatusV1InProgress = 'in_progress',
	CRMTaskStatusV1Completed = 'completed',
	CRMTaskStatusV1Canceled = 'canceled',
}

export interface UpdateCRMManagerTaskStatusRequestV1 {
	status: CRMTaskStatusV1;
	/**
	 * Необязательная реакция клиента при status=completed.
	 * Если указана, создаёт запись в истории коммуникаций, связанную с задачей.
	 * @minLength 1
	 * @maxLength 2000
	 */
	clientReaction?: string;
	/**
	 * Обязательно при status=canceled; причина отмены задачи.
	 * @minLength 1
	 * @maxLength 2000
	 */
	cancellationReason?: string;
}

export interface CreateCRMManagerTaskRequestV1 {
	/**
	 * @minLength 1
	 * @maxLength 255
	 */
	title: string;
	/**
	 * @minLength 1
	 * @maxLength 10000
	 */
	descriptionMd: string;
	/**
	 * Готовый текст сообщения клиенту в Markdown. Пустая строка сохраняется как отсутствие сообщения.
	 * @maxLength 10000
	 */
	messageMd?: string;
	/** @format date-time */
	deadlineAt: string;
}

export interface UpdateCRMManagerTaskRequestV1 {
	/**
	 * @minLength 1
	 * @maxLength 255
	 */
	title?: string;
	/**
	 * @minLength 1
	 * @maxLength 10000
	 */
	descriptionMd?: string;
	/**
	 * Готовый текст сообщения клиенту в Markdown. Пустая строка удаляет сообщение.
	 * @maxLength 10000
	 */
	messageMd?: string;
	/** @format date-time */
	deadlineAt?: string;
}

export interface CRMManagerTaskV1 {
	id: string;
	/** Идентификатор CRM-карточки клиента */
	crmClientId: string;
	studentUserId: string;
	studentLogin: string;
	/** Имя клиента из CRM-карточки */
	studentName?: string;
	/** Telegram клиента для личного общения без @ */
	personalTelegram?: string;
	/** Тип системной задачи. Для задачи по interestTopicId отсутствует. */
	type?: CRMTaskTypeV1;
	managerUserId: string;
	managerLogin: string;
	/** Топик, включение которого создало задачу. Для системной задачи отсутствует. */
	interestTopicId?: string;
	/** Стабильный идентификатор версии сообщения для защиты от повторной отправки. */
	messageId?: string;
	/** @format uuid */
	aiOutboxEventId?: string;
	status: CRMTaskStatusV1;
	title: string;
	/** Описание задачи в Markdown */
	descriptionMd: string;
	/** Готовый текст сообщения клиенту для копирования и отправки в Telegram */
	messageMd?: string;
	/** Причина отмены. Присутствует только у отменённой задачи. */
	cancellationReason?: string;
	/** @format date-time */
	createdAt: string;
	/** @format date-time */
	deadlineAt: string;
	/** @format date-time */
	completedAt?: string;
}

export interface CRMManagerTasksResponseV1 {
	total: number;
	items: CRMManagerTaskV1[];
}

export enum AIOutboxStatusV1 {
	AIOutboxStatusV1Pending = 'pending',
	AIOutboxStatusV1InProgress = 'in_progress',
	AIOutboxStatusV1Done = 'done',
	AIOutboxStatusV1Error = 'error',
}

export interface AIOutboxEventV1 {
	/** @format uuid */
	id: string;
	eventType: string;
	/** Логин пользователя, инициировавшего событие */
	userLogin: string;
	status: AIOutboxStatusV1;
	payload: Record<string, any>;
	/** Результат выполнения события в исходном JSON-формате */
	result?: any;
	error?: string;
	/** @format date-time */
	inProgressEndsAt?: string;
	inputTokensTotal?: number;
	outputTokensTotal?: number;
	requestDurationTotal?: number;
	/** @format date-time */
	createdAt: string;
	/** @format date-time */
	updatedAt: string;
}

export interface AIOutboxEventsResponseV1 {
	total: number;
	items: AIOutboxEventV1[];
}

export interface AIOutboxValidationFailedResponseV1 {
	message: 'ai_outbox_validation_failed';
}

export enum CRMAutomationEventStatusV1 {
	CRMAutomationEventStatusV1Error = 'error',
}

export enum CRMAutomationEventTypeV1 {
	CRMAutomationEventTypeV1ProgressReport = 'md_ai_report',
	CRMAutomationEventTypeV1Reactivation = 'crm_reactivation_message',
}

export interface CRMAutomationEventV1 {
	/** @format uuid */
	id: string;
	type: CRMAutomationEventTypeV1;
	status: CRMAutomationEventStatusV1;
	error?: string;
	/** @format date-time */
	createdAt: string;
	/** @format date-time */
	updatedAt: string;
}

export interface CRMAutomationEventsResponseV1 {
	items: CRMAutomationEventV1[];
}

export interface UpdateCRMClientRequestV1 {
	/**
	 * Имя клиента. Пустая строка очищает поле.
	 * @maxLength 255
	 */
	name?: string;
	dialogStatus?: CRMDialogStatusV1;
	/**
	 * Канонический грейд клиента. До заполнения onboarding имеет значение unknown;
	 * затем заполняется из анкеты и может быть изменён менеджером.
	 */
	clientGrade?: CRMClientGradeV1;
	/**
	 * Telegram login без @. Пустая строка очищает поле.
	 * @maxLength 32
	 * @pattern ^$|^[A-Za-z0-9_]+$
	 */
	personalTelegram?: string;
	/** @maxLength 2000 */
	clientRequest?: string;
	/** @maxLength 2000 */
	clientRequestStatus?: string;
	/** @maxLength 2000 */
	managerActions?: string;
	/** @maxLength 2000 */
	note?: string;
	/**
	 * Текущий статус подготовки. Повторная отправка того же значения
	 * подтверждает актуальность и обновляет interviewPreparationReceivedAt.
	 */
	interviewPreparationStatus?: CRMInterviewPreparationStatusV1;
	/** Стабильный optionId направления из onboarding-формы. */
	occupation?: CRMClientOccupationV1;
	/** Стабильный optionId основного языка из onboarding-формы. */
	primaryLanguage?: CRMPrimaryLanguageV1;
	/**
	 * Пустая строка очищает поле.
	 * @maxLength 128
	 */
	onboardingContact?: string;
	/**
	 * Пустая строка очищает поле.
	 * @maxLength 128
	 */
	interviewTiming?: string;
	/**
	 * @maxItems 100
	 * @uniqueItems true
	 */
	interestTopics?: string[];
	/**
	 * Пустая строка очищает поле.
	 * @maxLength 128
	 */
	studyTime?: string;
	/**
	 * Пустая строка очищает поле.
	 * @maxLength 128
	 */
	acquisitionSource?: string;
	/** Идентификатор из GET /v1/crm/stages. */
	stage?: CRMStageV1;
	entrySource?: CRMEntrySourceV1;
}

export interface CreateCRMClientActivityRequestV1 {
	/**
	 * @minLength 1
	 * @maxLength 2000
	 */
	summary: string;
}

export interface AssignCRMClientManagerRequestV1 {
	managerLogin: string;
}

export interface CRMManagerV1 {
	managerLogin: string;
	/** Общее число закреплённых за менеджером карточек; имя поля сохранено для обратной совместимости. */
	activeClients: number;
}

export interface CRMManagerListResponseV1 {
	managers: CRMManagerV1[];
}

export interface CRMClientNotFoundResponseV1 {
	message: 'crm_client_not_found';
}

export interface CRMResumeDownloadNotFoundResponseV1 {
	message: 'crm_client_not_found' | 'crm_resume_not_found';
}

export interface CRMClientManagerRequiredResponseV1 {
	message: 'crm_client_manager_required';
}

export interface CRMInvalidManagerResponseV1 {
	message: 'crm_invalid_manager';
}

export interface CRMValidationFailedResponseV1 {
	message: 'crm_validation_failed';
}

export interface CRMAutomationNotRetryableResponseV1 {
	message: 'crm_automation_not_retryable';
}

export interface CRMProgressReportGenerationResponseV1 {
	/**
	 * Идентификатор события генерации в AI outbox.
	 * @format uuid
	 */
	outboxId: string;
}

export interface CRMProgressReportConflictResponseV1 {
	message:
		| 'crm_progress_report_in_progress'
		| 'crm_progress_report_unavailable';
}

export interface UserActivityValidationFailedResponseV1 {
	message: 'user_activity_validation_failed';
}

export interface CRMLeadScoringEventV1 {
	eventName: string;
	unknownEventName?: string;
	score: number;
	/** @format date-time */
	eventTimestamp: string;
	eventURL: string;
	courseId?: string;
	problemId?: string;
	roadmapId?: string;
	theoryId?: string;
	utmSource?: string;
	utmMedium?: string;
	utmCampaign?: string;
	utmContent?: string;
	utmTerm?: string;
	eventPayload?: Record<string, any>;
}

export interface CRMClientLeadScoringResponseV1 {
	/** Количество событий за период (для пагинации) */
	total: number;
	/** Суммарный скор за весь период (по всем страницам) */
	totalScore: number;
	events: CRMLeadScoringEventV1[];
}

export interface CRMSubmissionV1 {
	id: string;
	problemId?: string;
	problemTitle?: string;
	status?: string;
	language?: string;
	/** @format date-time */
	submittedAt: string;
	code?: string;
	/** AI-generated submission report in Markdown */
	mdAiReport?: string;
	mdAiReportHasIssues?: boolean;
	/** @format date-time */
	mdAiReportCreatedAt?: string;
	/** users.id of the report creator in uppercase hex form */
	mdAiReportCreatorUserId?: string;
}

export interface CRMClientSubmissionsResponseV1 {
	total: number;
	items: CRMSubmissionV1[];
}

export interface UserActivityItemV1 {
	type: 'submission' | 'theory';
	/** ID сабмита или урока теории, в зависимости от type */
	id: string;
	/** Название задачи или урока теории */
	title: string;
	category?: ProblemCategoryEnum;
	/**
	 * Время сабмита или первого прохождения урока
	 * @format date-time
	 */
	occurredAt: string;
	problemId?: string;
	status?: string;
	/** Whether a submission already has an AI report; always false for theory */
	hasAiReport: boolean;
	/** Whether the AI report contains issues; absent when there is no report or for theory */
	mdAiReportHasIssues?: boolean;
	mdAiReportStatus?: MDAIReportStatusEnum;
}

/** @default "all" */
export enum UserActivityTypeFilterEnum {
	All = 'all',
	Submissions = 'submissions',
	Theory = 'theory',
}

/** @default "all" */
export enum UserActivitySubmissionResultFilterEnum {
	All = 'all',
	Successful = 'successful',
	Unsuccessful = 'unsuccessful',
}

export enum MDAIReportStatusEnum {
	MDAIReportStatusEnumPending = 'pending',
	MDAIReportStatusEnumInProgress = 'in_progress',
	MDAIReportStatusEnumDone = 'done',
	MDAIReportStatusEnumError = 'error',
}

export interface UserActivityResponseV1 {
	items: UserActivityItemV1[];
	/** Opaque cursor for the next page; absent when the feed is exhausted */
	nextCursor?: string;
}

export interface UserActivityDailyItemV1 {
	/**
	 * Календарная дата в UTC
	 * @format date
	 */
	date: string;
	/**
	 * Количество действий за день
	 * @min 0
	 */
	count: number;
}

export interface UserActivityDailyResponseV1 {
	/** @maxItems 90 */
	items: UserActivityDailyItemV1[];
}

export interface SurveyNotFoundResponseV1 {
	message: 'survey_not_found';
}

export interface SurveyExistsResponseV1 {
	message: 'survey_already_exists';
}

export interface SurveyLockedResponseV1 {
	message: 'survey_locked';
}

export interface SurveyResponseExistsResponseV1 {
	message: 'survey_response_exists';
}

export interface SurveyAnswerInvalidResponseV1 {
	message: 'survey_answer_invalid';
}

export interface SurveySchemaInvalidResponseV1 {
	message: 'blocks_validation_failed';
}

export interface CoursesV1 {
	courses: CourseInfoV1[];
}

export interface CourseInfoV1 {
	id: string;
	name: string;
	description: string;
}

export interface SubmitRequestWithTestsV1 {
	problemID?: string;
	base64Code: string;
	languageID: number;
	tests: string;
}

export interface SubmitRequestV1 {
	problemID?: string;
	base64Code: string;
	languageID: number;
}

export interface SubmitResponseV1 {
	submissionID: string;
}

export interface SubmissionResponseV1 {
	status: string;
	content: ContentBlockV1[];
	aiContent: ContentBlockV1[];
	isReportGenerated: boolean;
	reportStatus: AIReportStatusV1;
}

export interface ContentBlockV1 {
	id: string;
	type:
		| 'header'
		| 'paragraph'
		| 'codeEditor'
		| 'solutionChart'
		| 'chart'
		| 'code'
		| 'headerSpark'
		| 'quote'
		| 'alert'
		| 'nestedList'
		| 'image'
		| 'embed'
		| 'breakLine'
		| 'unknown'
		| 'table'
		| 'test'
		| 'accordion';
	data:
		| ContentBlockHeaderV1
		| ContentBlockParagraphV1
		| ContentBlockCodeSnippetV1
		| ContentBlockCodeV1
		| ContentBlockSolutionChartV1
		| ContentBlockChartV1
		| ContentBlockHeaderSparkV1
		| ContentBlockQuoteV1
		| ContentBlockAlertV1
		| ContentBlockNestedListV1
		| ContentBlockImageV1
		| ContentBlockVideoV1
		| ContentBlockBreakLineV1
		| ContentBlockUnknownV1
		| ContentBlockTableV1
		| ContentBlockTestV1
		| ContentBlockAccordionV1
		| ContentBlockAccordionArrayV1;
}

export interface ContentBlockAccordionArrayV1 {
	items: ContentBlockAccordionV1[];
}

export interface ContentBlockAccordionV1 {
	title: string;
	content: ContentBlockV1[];
}

export interface ContentBlockHeaderV1 {
	text: string;
	level: number;
}

export interface ContentBlockParagraphV1 {
	text: string;
}

export interface ContentBlockCodeSnippetV1 {
	value: {
		code: string;
	};
}

export interface ContentBlockCodeV1 {
	collapse: boolean;
	value: {
		csharp?: string;
		cpp?: string;
		go?: string;
		java?: string;
		kotlin?: string;
		python?: string;
		swift?: string;
		typescript?: string;
		javascript?: string;
		postgreSQL?: string;
		json?: string;
		yaml?: string;
		sql?: string;
		xml?: string;
		bash?: string;
	};
}

export interface ContentBlockSolutionChartV1 {
	data: {
		solutionBenchmark: number[];
		userBenchmark: number[];
	};
}

export interface ContentBlockChartV1 {
	type: string;
	data: LineChart;
	options?: object;
}

export interface LineChart {
	labels: string[];
	datasets: LineChartDataset[];
}

export interface LineChartDataset {
	label: string;
	data: number[];
}

export interface ContentBlockHeaderSparkV1 {
	text: string;
	level: number;
	style?: 'gradient';
}

export interface ContentBlockQuoteV1 {
	text: string;
	alignment: 'left' | 'center';
}

export type ContentBlockAlertV1 = any;

export interface ContentBlockNestedListV1 {
	style: 'unordered' | 'ordered';
	items: ContentBlockListContentV1[];
}

export interface ContentBlockListContentV1 {
	content: string;
	items?: ContentBlockListContentV1[];
}

export interface ContentBlockVideoV1 {
	value: {
		id: string;
		caption?: string;
	};
}

export interface ContentBlockImageV1 {
	value: {
		file: string;
		align?: 'left' | 'center' | 'right';
		fullsize?: boolean;
	};
}

export interface ContentBlockBreakLineV1 {
	divider: boolean;
}

export type ContentBlockUnknownV1 = object;

export interface ContentBlockTableV1 {
	headerRow: boolean;
	headerCol: boolean;
	content: string[][];
	/** Стиль фона строки таблицы, по индексу совпадает с `content` (включая строку-шапку, если `headerRow` — первая строка `content`). Те же значения, что у code-snippet `type`. */
	rowTypes?: ContentBlockTableRowTypeV1[];
}

export enum ContentBlockTableRowTypeV1 {
	Default = 'default',
	Error = 'error',
	Success = 'success',
}

export interface ContentBlockTestV1 {
	testType: TestTypes;
	data: TestContentV1;
	testID: string;
}

export interface TestContentV1 {
	question: ContentBlockV1[];
	choices: TestChoiceV1[];
	options?: string[];
}

export interface TestChoiceV1 {
	id: number;
	content: ContentBlockV1[];
}

export interface SolutionPromptV1 {
	problemID: string;
	prompt: ContentBlockV1[];
	/** @format date-time */
	createdAt: string;
}

export interface CodeLanguagesV1 {
	id: number;
	name: string;
	slug: string;
	judgeLanguageID: number;
}

export interface SandboxCodeV1 {
	sourceCode: string;
	languageID: number;
}

export interface UpdateProblemResourceV1 {
	codeLanguageID: number;
	templateCode: string;
}

export interface ImportLessonRequestV1 {
	id: string;
	title: string;
	isFree?: boolean;
	isVisible?: boolean;
	isPublic?: boolean;
	isNew?: boolean;
	unisenderEventId?: string;
	content?: Record<string, any>[];
}

export interface ImportLessonResponseV1 {
	id: string;
}

export interface ImportCourseRequestV1 {
	id: string;
	name: string;
	description?: string;
	difficulty: number;
	planName: string;
	planDescription?: string;
	subtopics: ImportCourseSubtopicV1[];
}

export interface ImportCourseSubtopicV1 {
	name: string;
	lessons: UpdateCourseLessonV1[];
}

export interface ImportCourseResponseV1 {
	id: string;
}

export interface ImportProblemRequestV1 {
	id: string;
	title: string;
	difficulty: number;
	category: ProblemCategoryEnum;
	handlingType: string;
	descriptionPrompt?: object[];
	solutionPrompt?: object[];
	templates: ProblemTemplateV1[];
	companies?: string[];
}

export interface ImportProblemResponseV1 {
	id: string;
}

export interface ProblemTemplateV1 {
	languageId: number;
	code: string;
}

export interface CreateProblemRequestV1 {
	id: string;
	title: string;
	category: ProblemCategoryEnum;
	/**
	 * Optional handling type override for algorithm problems.
	 * Use "class-algorithms" to create a class-based algorithm problem.
	 */
	handlingType?: string;
}

export interface CreateProblemWithAIRequestV1 {
	model: string;
	/** slug задачи через дефис */
	slug: string;
	difficulty: number;
	template: AICreateAlgorithmProblemTemplateV1;
	prompt: string;
	solutionHintPrompt: string;
	examplesPrompt: string;
	company: string[];
}

export interface AICreateAlgorithmProblemTemplateV1 {
	/** Имя функции в snake case */
	funcName: string;
	/**
	 * Входные параметры функции (порядок важен)
	 * @minItems 0
	 */
	testInputTypes: TestInputType[];
	testOutputType: TestOutputType;
}

export interface CreateProblemWithAI200ResponseV1 {
	id: string;
}

export interface GetCreateProblemWithAIStatusResponseV1 {
	status: string;
	error?: string;
	issues?: ContentBlockV1[];
}

export interface CreateProblemWithAI400ResponseV1 {
	message: 'not_valid_input_data' | 'slug_exists';
}

export interface CreateProblemResponseV1 {
	id: string;
}

export interface UpdateProblemRequestV1 {
	version: number;
	title?: string;
	isVisible?: boolean;
	isNew?: boolean;
	difficulty?: number;
	handlingType?: string;
	descriptionPrompt?: Record<string, any>[];
	solutionPrompt?: Record<string, any>[];
	companies?: string[];
	resources?: UpdateProblemResourceV1[];
	permissionLevel?: PermissionLevelV1;
}

export interface UpdateProblemResponse422ErrorV1 {
	message:
		| 'solution_tests_failed'
		| 'cannot_update_critical_fields_for_visible_problem';
}

export interface ProblemV1 {
	id: string;
	title: string;
	difficulty: number;
	correctSubmissionsCount: number;
	failureSubmissionsCount: number;
	maxWallTimeLimitSeconds: number;
	maxMemoryKilobytes: number;
	maxStackFramesCount: number;
	/** @format date-time */
	createdAt: string;
	descriptionPrompt: ContentBlockV1[];
	isVisible: boolean;
	isFree: boolean;
	isSolved: boolean;
	hasVideo: boolean;
	hasTests: boolean;
	suggestionFormId: string;
	issueFormId: string;
	companies: string[];
	category: ProblemCategoryEnum;
	version: number;
	isNew: boolean;
	handlingType:
		| 'unknowm'
		| 'algorithm'
		| 'algorithms-v2'
		| 'class-algorithms'
		| 'problem'
		| 'pg_sql_select'
		| 'java-advanced'
		| 'python-advanced'
		| 'cpp-advanced'
		| 'golang-advanced';
	permissionLevel: PermissionLevelV1;
}

export interface ProblemResourceV1 {
	problemID: string;
	codeLanguageID: number;
	codeLanguageName?: string;
	codeLanguageSlug: string;
	templateSolutionCode: string;
	studentSandboxCode: string;
	lastStudentSuccessfulSolution: string;
	codeLanguageVersion?: string;
}

export interface ProblemVideoExplanationV1 {
	prompt: ContentBlockV1[];
}

export interface ProblemTestsV1 {
	problemID: string;
	prompt: ContentBlockV1[];
}

export interface AlgoCoursePlanV1 {
	name: string;
	description: string;
	difficulty: number;
	video?: string;
	image: string;
	courseTopics: CourseTopicV1[];
}

export interface AlgoCoursePlanGroupV1 {
	isVisible: boolean;
	isPublic: boolean;
	plans: AlgoCoursePlanV1[];
	description?: string;
	name: string;
	version: number;
	difficulty?: number;
	team?: TeamMemberV1[];
	permissionLevel: PermissionLevelV1;
}

export interface RoadMapV1 {
	id: string;
	roadmap: RoadMapGroupV1[];
	name: string;
	description: string;
	version: number;
	color: string;
	isVisible: boolean;
	image: string;
	isPublic: boolean;
	permissionLevel: PermissionLevelV1;
}

export interface RoadMapGroupV1 {
	topics: RoadMapItemV1[];
	name: string;
	isVisible: boolean;
}

export interface RoadMapItemV1 {
	name: string;
	slug: string;
	description: string;
	image: string;
	type: RoadMapItemTypeV1;
}

export enum RoadMapItemTypeV1 {
	Course = 'course',
	Exerciser = 'exerciser',
}

export enum PermissionLevelV1 {
	Public = 'public',
	Regular = 'regular',
	Advanced = 'advanced',
}

export interface UpdateRoadMapRequestV1 {
	roadmap?: RoadMapGroupV1[];
	name?: string;
	description?: string;
	version: number;
	isVisible?: boolean;
	image?: string;
	color?: string;
	isPublic?: boolean;
	permissionLevel?: PermissionLevelV1;
}

export interface CourseV1 {
	id: string;
	name: string;
	image: string;
	description: string;
	difficulty: number;
	isHasCoursePlan: boolean;
}

export interface CreateRoadMapRequestV1 {
	id: string;
}

export interface CreateRoadMapResponseV1 {
	id: string;
}

export interface CreateCourseRequestV1 {
	id: string;
}

export interface CreateCourseResponseV1 {
	id: string;
}

export interface ProductIDV1 {
	id: string;
}

export interface CourseIDV1 {
	id: string;
}

export interface CreateTheoryRequestV1 {
	/** new title for theory */
	title: string;
}

export interface UpdateTheoryRequestV1 {
	/** new title for theory */
	title?: string;
	/** new order of lessons in theory */
	lessonsOrder?: string[];
}

export interface TheoryLessonIdV1 {
	id: string;
}

export interface CreateTheoryLessonRequestV1 {
	title: string;
	type: string;
}

export interface UpdateStaticLessonRequestV1 {
	/** new title for lesson */
	title?: string;
	/** new content for lesson */
	content?: string;
}

export interface ListCourseVersionsV1 {
	versions: CourseVersionV1[];
}

export interface CourseVersionV1 {
	version: number;
	id: string;
	isCurrent: boolean;
}

export interface CreateLessonRequestV1 {
	title: string;
	category?: ProblemCategoryEnum;
}

export interface CreateLessonResponseV1 {
	id: string;
}

export interface UpdateLessonRequestV1 {
	version: number;
	isPublic?: boolean;
	isFree?: boolean;
	isVisible?: boolean;
	title?: string;
	isNew?: boolean;
	content?: Record<string, any>[];
	/** ID триггер-блока в UniSender. Если задан — урок является чек-поинтом. */
	unisenderEventId?: string;
	permissionLevel?: PermissionLevelV1;
	category?: ProblemCategoryEnum;
}

export interface TheoryV1 {
	id: string;
	title: string;
	content: LessonV1[];
}

export interface LessonV1 {
	id: string;
	type: string;
	title: string;
	passed: boolean;
}

export interface StaticLessonV1 {
	id: string;
	version: number;
	content: ContentBlockV1[];
	suggestionFormId: string;
	issueFormId: string;
	tasks?: TheoryTestsAnswerV1[];
	tests?: TheoryTestsItemV1[];
	passed?: boolean;
	title: string;
	isFree: boolean;
	isVisible: boolean;
	isNew: boolean;
	isPublic: boolean;
	/** ID триггер-блока в UniSender. Если задан — урок является чек-поинтом. */
	unisenderEventId?: string;
	permissionLevel: PermissionLevelV1;
	category?: ProblemCategoryEnum;
}

/** attempt to solve a task */
export interface TheoryTestsUserSubmissionsV1 {
	/**
	 * answer
	 * @example "0100"
	 */
	proposedAnswer: string;
}

/** state of the Task */
export interface SolvedTask {
	/** state of the Task */
	isSolved: boolean;
}

/** server's answer */
export interface TheoryTestsAnswerV1 {
	/**
	 * task id
	 * @example "reliability-1-homework-1"
	 */
	id: string;
	/** was answer correct */
	isCorrect: boolean;
	/**
	 * answer
	 * @example "0100"
	 */
	correctAnswer?: string;
	/**
	 * info why this is an answer
	 * @example "Because 1 + 1 = 2"
	 */
	explantion?: string;
	/**
	 * how complicated task was and how much it's weight is
	 * @example 15
	 */
	cost?: number;
	/** if 0 than correct answer is returned */
	attemptsLeft: number;
}

export interface TheoryFeedbackFormV1 {
	formId: string;
	theory: FeedbackFormPart;
	video: FeedbackFormPart;
}

export interface ProblemFeedbackFormV1 {
	formId: string;
	problem: FeedbackFormPart;
	video: FeedbackFormPart;
	solution: FeedbackFormPart;
}

export interface FeedbackFormPart {
	title: string;
	question: string;
	sourceId: SourceTypeEnum;
	options: string[];
}

export type CreateTheoryPassRequestV1 = object;

export interface CreateTheoryPassResponseV1 {
	message: string;
}

export interface CreateFeedbackRequestV1 {
	formId: string;
	sourceId: SourceTypeEnum;
	/** @maxLength 1024 */
	comment: string;
	/** @default false */
	option1?: boolean;
	/** @default false */
	option2?: boolean;
	/** @default false */
	option3?: boolean;
	/** @default false */
	option4?: boolean;
	/** @default false */
	option5?: boolean;
}

export interface CreateFeedbackResponseV1 {
	message: string;
}

export enum SourceTypeEnum {
	Problem = 'problem',
	Video = 'video',
	Solution = 'solution',
	Theory = 'theory',
}

export interface CreateUserRequestV1 {
	login: string;
	password: string;
	email: string;
	emailCode: string;
	promoCode?: string;
	advertisingMail: boolean;
}

export interface CreateUserResponseV1 {
	message: string;
}

export interface CreateEmailVerificationCodeRequestV1 {
	email: string;
	promoCode?: string;
}

export interface CreateEmailVerificationCodeResponseV1 {
	message: string;
}

export interface LoginByTokenRequestV1 {
	token: string;
}

export interface LoginByToken403ErrorResponse {
	message: 'one_time_token_used' | 'one_time_token_expired';
}

export interface LoginByToken404ErrorResponse {
	message: 'one_time_token_not_found';
}

export interface CreateAuthTokenV1 {
	login: string;
	password: string;
}

export interface CreateAuthTokenResponseV1 {
	message: string;
}

export interface UpdateUserPasswordRequestV1 {
	password: string;
	email: string;
	verificationCode: string;
}

export interface UpdateUserPasswordResponseV1 {
	message: string;
}

export interface CreatePasswordRestoreCodeResponseV1 {
	message: string;
}

export interface CreatePasswordRestoreCodeRequestV1 {
	email: string;
}

export interface UpdateCourseV1 {
	name?: string;
	image?: string;
	description?: string;
	summary?: string;
	difficulty?: number;
	version: number;
	isVisible?: boolean;
	isPublic?: boolean;
	plans?: UpdateCoursePlanV1[];
	team?: UpdateTeamMemberV1[];
	permissionLevel?: PermissionLevelV1;
}

export interface UpdateCoursePlanV1 {
	name: string;
	/** Путь к иконке/картинке курса */
	image?: string;
	description: string;
	difficulty: number;
	courseTopics: UpdateCourseTopicV1[];
}

export interface UpdateCourseTopicV1 {
	name: string;
	courseSubTopic: UpdateCourseSubtopicV1[];
}

export interface UpdateCourseSubtopicV1 {
	name: string;
	summary?: string;
	courseLesson: UpdateCourseLessonV1[];
}

export interface UpdateCourseLessonV1 {
	id: string;
	type: CourseLessonTypes;
}

export interface UpdateTeamMemberV1 {
	name: string;
	image: string;
	description: string;
}

export interface CourseTheoryIDV1 {
	id: string;
}

export interface CourseTopicV1 {
	name: string;
	courseSubTopic: CourseSubTopicV1[];
	isVisible: boolean;
}

export interface CourseSubTopicV1 {
	name: string;
	summary?: string;
	theory?: CourseTheoryV1;
	courseLesson?: CourseLessonV1[];
}

export interface CourseLessonV1 {
	tags?: ProblemTagV1[];
	name: string;
	type: CourseLessonTypes;
	id: string;
	isFree: boolean;
	isSolved: boolean;
	difficulty?: number;
	isVisible: boolean;
	hasVideo: boolean;
	hasTests: boolean;
	isNew: boolean;
}

export interface CourseTheoryV1 {
	id: string;
	name: string;
	isFree: boolean;
}

export interface UserV1 {
	/** Internal user identifier */
	id: string;
	login: string;
	email: string;
	/** Есть подтверждённая покупка курса без возврата, в том числе с истёкшим сроком доступа. Не является проверкой действующего доступа. */
	hasPurchasedCourses: boolean;
	/** Заполнил ли пользователь онбординг-анкету */
	onboarding: boolean;
	contentPermissionLevel: PermissionLevelV1;
	accessTier?: string;
	subscriptionId?: string;
	productsID: string[];
	telegram?: TelegramUserInfoV1;
	role: UserRole;
	advertisingMail?: boolean;
	acceptedNewLegalEntity?: boolean;
	/** Личный менеджер пользователя. Присутствует, только если менеджер назначен. */
	personalManager?: PersonalManagerV1;
	/** Saved model for learning AI features. New users receive claude-haiku-4-5; the first successful payment assigns claude-sonnet-5 once. Expiration, refunds and subsequent payments do not reset the preference. */
	defaultAIModel: string;
	/** User's preferred programming language as a codeLanguages id (1=python, 2=cpp, 3=golang, 4=java, 5=csharp, 6=javascript, ...). Omitted when the user has not chosen one. */
	primaryLanguageId?: number;
}

/** Личный менеджер пользователя. Присутствует, только если менеджер назначен. */
export interface PersonalManagerV1 {
	/** Telegram username менеджера для связи. Может отсутствовать, если менеджер не привязал Telegram. */
	telegramUsername?: string;
}

export enum UserRole {
	User = 'user',
	Admin = 'admin',
	Editor = 'editor',
	CommunityManager = 'community-manager',
}

export interface UpdateSelfPrimaryLanguageRequestV1 {
	/** codeLanguages id to set as the user's primary language (1=python, 2=cpp, 3=golang, 4=java, 5=csharp, 6=javascript, ...). */
	languageId: number;
}

export interface UpdateSelfPrimaryLanguage400ResponseV1 {
	message: 'invalid_primary_language';
}

export interface TelegramUserInfoV1 {
	/** @format int64 */
	id: number;
	firstName: string;
	lastName?: string;
	username?: string;
}

export interface TelegramUserRulesV1 {
	isAlgorithmsPremium: boolean;
	role: UserRole;
}

export interface CheckAccessForKinescopeVideoRequestV1 {
	id: string;
	ip?: string;
	type?: string;
	token: string;
	user_agent?: string;
}

export interface PaymentRequestV1 {
	id: string;
}

export type SubscriptionsResponseV1 = SubscriptionResponseV1[];

export interface SubscriptionResponseV1 {
	name: string;
	days: number;
	subscriptionId: string;
	isPromoAllowed: boolean;
	canBeBoughtWithActivePremium: boolean;
	subscriptionInfo: SubscriptionInfo;
	loanPaymentInfo: LoanPaymentInfo;
	oneTimePaymentInfo: OneTimePaymentInfo;
	dolyamiPaymentInfo: DolyamiPaymentInfo;
}

export interface SubscriptionInfo {
	name: string;
	description: string;
	hasCommunityAccess: boolean;
	features: string[];
	miniFeatures: string[];
	topHeadline: string;
	bottomHeadline: string;
	displayStyle: 'default' | 'new-year-promo' | 'white' | 'black';
}

export interface SubscriptionPaymentInfoResponseV1 {
	subscriptionId: string;
	canBeBoughtWithActivePremium: boolean;
	isPromoAllowed: boolean;
	name: string;
	days: number;
	loanPaymentInfo: LoanPaymentInfo;
	oneTimePaymentInfo: OneTimePaymentInfo;
	dolyamiPaymentInfo: DolyamiPaymentInfo;
}

export type ProductTariffsResponseV1 = ProductTariffResponseV1[];

export interface ProductTariffResponseV1 {
	tariffId: string;
	tariffInfo: TariffInfo;
	loanPaymentInfo: LoanPaymentInfo;
	oneTimePaymentInfo: OneTimePaymentInfo;
	dolyamiPaymentInfo: DolyamiPaymentInfo;
}

export interface ProductTariffPaymentInfoResponseV1 {
	tariffId: string;
	/** @format date-time */
	discountEndDate: string;
	discountActive: boolean;
	name: string;
	loanPaymentInfo: LoanPaymentInfo;
	oneTimePaymentInfo: OneTimePaymentInfo;
	dolyamiPaymentInfo: DolyamiPaymentInfo;
}

export interface TariffInfo {
	unlimitedPlaces: boolean;
	places: number;
	name: string;
	description: string;
	/** @format date-time */
	startDate?: string;
	/** @format date-time */
	endDate?: string;
	/** @format date-time */
	discountEndDate: string;
	discountActive: boolean;
	hasCommunityAccess: boolean;
	features: string[];
}

export interface LoanPaymentInfo {
	providerId: ProviderId;
	startingFromPerMonth: number;
	price: number;
	discountPrice: number;
	enabled: boolean;
	options: LoanOption[];
}

export interface OneTimePaymentInfo {
	providerId: ProviderId;
	price: number;
	discountPrice: number;
	enabled: boolean;
	meta?: OneTimePaymentInfoMeta;
}

export interface OneTimePaymentInfoMeta {
	monthlyPrice: number;
	monthlyDiscountPrice: number;
}

export interface DolyamiPaymentInfo {
	providerId: ProviderId;
	price: number;
	discountPrice: number;
	enabled: boolean;
	meta: DolyamiPaymentInfoMeta;
}

export interface DolyamiPaymentInfoMeta {
	price: number;
}

export interface LoanOption {
	duration: string;
	perMonth: number;
}

export interface InitProductPaymentV1 {
	/** @min 1 */
	productVersion?: number;
	promoCode?: string;
	productType: string;
	productId: string;
	/** @default false */
	isAnonymous?: boolean;
	userEmail?: string;
	/** @default false */
	advertisingMail?: boolean;
	providerId: ProviderId;
	providerInput: ProviderInput;
}

export enum ProviderId {
	TinkoffAcquiring = 'tinkoff_acquiring',
	TinkoffLoans = 'tinkoff_loans',
	TinkoffPartial = 'tinkoff_partial',
}

export type ProviderInput = TinkoffAcqData | TinkoffLoansData;

export interface TinkoffAcqData {
	recurrent: boolean;
}

export interface TinkoffLoansData {
	duration?: string;
}

export interface PaymentUrlSuccessV1 {
	paymentUrl: string;
}

export interface SuccessPaymentV1 {
	message: string;
}

export interface SuccessCancellingPaymentV1 {
	message: string;
}

export interface UploadProblemTemplateV1 {
	/** @format binary */
	file: File;
}

export interface UploadProblemTestsV1 {
	/** @format binary */
	file: File;
}

export enum ProblemCategoryEnum {
	Algorithms = 'algorithms',
	SystemDesign = 'system-design',
	SoftSkills = 'soft-skills',
	Golang = 'golang',
	Sql = 'sql',
	Java = 'java',
	Python = 'python',
	Cpp = 'cpp',
}

export interface TinkoffPaymentNotificationV1 {
	/** @maxLength 20 */
	TerminalKey?: string;
	/**
	 * @format uint64
	 * @maxLength 10
	 */
	Amount?: number;
	/** @maxLength 36 */
	OrderId?: string;
	Success?: boolean;
	/** @maxLength 20 */
	Status?: string;
	/**
	 * @format uint64
	 * @maxLength 20
	 */
	PaymentId?: number;
	/** @maxLength 20 */
	ErrorCode?: string;
	Message?: string;
	Details?: string;
	/**
	 * @format uint64
	 * @maxLength 20
	 */
	RebillId?: number;
	/** @format uint64 */
	CardId?: number;
	Pan?: string;
	ExpDate?: string;
	Token?: string;
}

export interface UserPaymentHistoryResponseV1 {
	total: number;
	items: UserPaymentHistoryItemV1[];
}

export interface UserPaymentHistoryItemV1 {
	name: string;
	/** @format date-time */
	date: string;
	payment?: HistoryPaymentInfoV1;
}

export interface HistoryPaymentInfoV1 {
	canRefund?: boolean;
	productType?: string;
	orderId: string;
	status:
		| 'paid'
		| 'rejected'
		| 'canceled'
		| 'pending_commit'
		| 'cancelling'
		| 'canceling'
		| 'committing';
	type: PaymentTypeV1;
	amount: number;
	paymentMethod: ProviderId;
	promoCode?: string;
}

export type PaymentHistoryResponseV1 = PaymentHistoryItemV1[];

export interface PaymentHistoryItemV1 {
	productName: string;
	paymentStatus: 'paid' | 'failed' | 'rejected' | 'canceled' | 'pending_commit';
	amount: number;
	currency: 'rub' | 'usd' | 'eur';
	/** @format date-time */
	date: string;
	paymentMethod?: ProviderId;
	cardType?: string;
	paymentInfo?: string;
	productType?: 'offline_stream' | 'tariff' | 'subscription';
}

export interface ActiveSubscriptionResponseV1 {
	id: string;
	accessTier: string;
	amount: number;
	subscriptionName: string;
	/** @format date-time */
	expirationDate: string;
	/** @format date-time */
	nextPaymentDate?: string;
	recurrentEnabled: boolean;
	label?: string;
	cardInfo?: UserCardV1;
}

export interface UserCardV1 {
	lastFourDigits: string;
	firstSixDigits: string;
	expirationDate: string;
}

export interface SuccessDisablingRecurrentV1 {
	message: string;
}

export interface AcceptNewLegalEntityRequestV1 {
	advertisingMail: boolean;
}

export interface AcceptNewLegalEntityResponseV1 {
	message: string;
}

export enum SubscriptionTypeEnum {
	Month = 'month',
	Semiannual = 'semiannual',
	Year = 'year',
	Quarter = 'quarter',
	Online = 'online',
}

export enum CurrencyEnum {
	Rub = 'rub',
	Usd = 'usd',
	Eur = 'eur',
}

export interface DeleteUserProgressResponseV1 {
	message: string;
}

export type GetListProblemFilesResponseV1 = ProblemFileInfoV1[];

export interface ProblemFileInfoV1 {
	name: string;
	/** @format int64 */
	size: number;
	/** @format date-time */
	lastModified: string;
	languageId?: number;
	eTag?: string;
}

export interface OkResponse {
	message: 'OK';
}

export interface NotAuthorized {
	message: string;
}

export interface AccessDenied {
	message: string;
}

export interface ResourceNotFound {
	message: string;
}

export interface VerifySuccessPaymentErrorResponse {
	message: 'order_not_paid';
}

export interface OrderNotCancellable {
	message: string;
}

export interface CreatePayment400ResponseV1 {
	message:
		| 'promo_code_expired'
		| 'user_has_already_paid'
		| 'promo_code_not_available'
		| 'anonymous_payment_disabled'
		| 'payment_method_not_available';
}

export interface UserLoginErrorResponse {
	message: 'invalid_user_credentials';
}

export interface UserRegistration400ErrorResponse {
	message:
		| 'password_too_weak'
		| 'password_too_short'
		| 'promo_code_limit_exceeded';
}

export interface UserRegistration403ErrorResponse {
	message: 'email_already_taken' | 'login_already_taken' | 'otp_not_matched';
}

export interface UserRegistration404ErrorResponse {
	message: 'promo_code_not_found';
}

export interface CreateEmailVerificationCode400ErrorResponse {
	message: 'promo_code_limit_exceeded';
}

export interface CreateEmailVerificationCode403ErrorResponse {
	message: 'email_already_taken';
}

export interface CreateEmailVerificationCode404ErrorResponse {
	message: 'promo_code_not_found';
}

export interface UpdateUserPassword400ErrorResponse {
	message: 'password_too_weak' | 'password_too_short';
}

export interface UpdateUserPassword403ErrorResponse {
	message: 'otp_not_matched';
}

export interface PaymentFailure {
	status: string;
}

export interface PaymentSuccess {
	status: string;
}

export interface LastSubmissionAiReportV1 {
	status: AIReportStatusV1;
}

export interface GenerateSubmissionAiReportV1 {
	message: string;
}

export enum AIReportStatusV1 {
	None = 'none',
	Done = 'done',
	Pending = 'pending',
	Error = 'error',
}

export enum CourseLessonTypes {
	TheoryLesson = 'theoryLesson',
	AlgoProblem = 'algoProblem',
	VideoLesson = 'videoLesson',
	CandidateInterview = 'candidateInterview',
	InterviewSimulator = 'interviewSimulator',
	AiProblem = 'aiProblem',
	AiInterview = 'aiInterview',
	AiPractice = 'aiPractice',
	AiTheory = 'aiTheory',
}

export enum TestTypes {
	SingleChoice = 'singleChoice',
	MultiChoice = 'multiChoice',
	TextInput = 'textInput',
	MatchPairs = 'matchPairs',
	RangeCalc = 'rangeCalc',
}

export interface TheoryTestRequestV1 {
	testAnswer: string;
}

export interface TheoryTestSubmissionResponseV1 {
	isCorrect: boolean;
	answerText: string;
	testType: TestTypes;
	answer: string;
}

export interface TheoryTestsItemV1 {
	testType: TestTypes;
	testID: string;
	answerText?: string;
	isCorrect?: boolean;
	answer?: string;
}

export interface TeamMemberV1 {
	name: string;
	description: string;
	image: string;
}

export enum LeadScoreEventNameType {
	Registration = 'registration',
	OpenProblem = 'openProblem',
	SuccessProblemSubmit = 'successProblemSubmit',
	FailProblemSubmit = 'failProblemSubmit',
	OpenTheoryLesson = 'openTheoryLesson',
	SolveTheoryLesson = 'solveTheoryLesson',
	OpenPaymentPage = 'openPaymentPage',
	SelectPaymentMethod = 'selectPaymentMethod',
	OpenBankPaymentPage = 'openBankPaymentPage',
	SuccessfulPurchase = 'successfulPurchase',
	FailedPurchase = 'failedPurchase',
	ClosePaymentPage = 'closePaymentPage',
	OpenCourse = 'openCourse',
	OpenRoadmap = 'openRoadmap',
	OpenMiniCourse = 'openMiniCourse',
	WebinarRegistration = 'webinarRegistration',
	WebinarOpen = 'webinarOpen',
	WebinarClosed = 'webinarClosed',
}

export interface LeadScoreEventLog {
	eventURL: string;
	courseId?: string;
	roadmapId?: string;
	problemId?: string;
	theoryId?: string;
	eventName: LeadScoreEventNameType;
	/** @format date-time */
	eventTimestamp: string;
	utmSource?: string;
	utmMedium?: string;
	utmCampaign?: string;
	utmContent?: string;
	utmTerm?: string;
	eventPayload?: Record<string, any>;
}

export interface TelegramUserV1 {
	/** @format int64 */
	telegramUserId: number;
	telegramUserFirstName: string;
	isBot: boolean;
	telegramUserLastName?: string;
	telegramUserLanguageCode?: string;
}

export interface TelegramAuth {
	/** @format uuid */
	authToken: string;
}

export interface TelegramAuth400ErrorResponse {
	message:
		| 'user_already_has_linked_telegram_account'
		| 'wrong_telegram_auth_token'
		| 'telegram_auth_token_expired';
}

export interface UpdateCoursePlan400Response {
	message:
		| 'dirty_version'
		| 'invalid_theories'
		| 'invalid_simulators'
		| 'invalid_problems'
		| 'invalid_videos';
}

export type ProblemListV1 = ProblemListItemV1[];

export interface ProblemListItemV1 {
	id: string;
	name: string;
	isFree: boolean;
	isVisible: boolean;
	isSolved: boolean;
	isNew: boolean;
	difficulty: number;
	hasVideo: boolean;
	companies: string[];
}

export type LessonListResponseV1 = LessonListItemV1[];

export interface LessonListItemV1 {
	id: string;
	name: string;
	isFree: boolean;
	isVisible: boolean;
	/** @format date-time */
	createdAt: string;
}

export interface ConnectTelegramRequestV1 {
	/** @format int64 */
	id: number;
	firstName: string;
	lastName?: string;
	username?: string;
	photoUrl?: string;
	/** @format int64 */
	authDate: number;
	hash: string;
}

export interface ConnectTelegram400ErrorResponseV1 {
	message: 'wrong_telegram_auth_token' | 'telegram_auth_token_expired';
}

export interface ConnectTelegramWithBotResponseV1 {
	deepLink: string;
	/** @format date-time */
	expiresAt: string;
}

export interface ConfirmTelegramLinkRequestV1 {
	token: string;
	/** @format int64 */
	telegramId: number;
	username?: string;
	firstName: string;
	lastName?: string;
}

export interface ConfirmTelegramLink400ResponseV1 {
	message:
		| 'telegram_link_token_invalid'
		| 'telegram_link_token_expired'
		| 'telegram_already_linked_to_another_account';
}

export interface LinkTelegramCredentialsRequestV1 {
	login: string;
	password: string;
	/** @format int64 */
	telegramId: number;
	username?: string;
	firstName: string;
	lastName?: string;
}

export interface LinkTelegramCredentials409ResponseV1 {
	message: string;
}

export interface UpdateCourse400ErrorResponse {
	message: 'invalid_courses';
}

export enum FeedbackTargetEnumV1 {
	FeedbackTargetEnumV1Problem = 'problem',
	FeedbackTargetEnumV1Theory = 'theory',
	FeedbackTargetEnumV1AiProblem = 'ai_problem',
}

export interface PostUserFeedbackRequestV1 {
	targetType: FeedbackTargetEnumV1;
	targetId: string;
	title: string;
	message: string;
}

export type FeedbackListResponseV1 = FeedbackListItemV1[];

export interface FeedbackListItemV1 {
	title: string;
	targetType: FeedbackTargetEnumV1;
	targetId: string;
	feedbacks: FeedbackContentV1[];
}

export interface FeedbackContentV1 {
	id: string;
	userLogin: string;
	title: string;
	message: string;
	isResolved: boolean;
	/** @format date-time */
	createdAt: string;
}

export interface UpdateFeedbackRequestV1 {
	isResolved: boolean;
}

export interface CreateUserAIProblemFeedbackRequestV1 {
	/** @pattern ^[0-9A-Fa-f]{32}$ */
	ai_dialog_id?: string;
	/**
	 * @min 1
	 * @max 2147483647
	 */
	ai_message_id?: number;
	/**
	 * @minLength 1
	 * @maxLength 128
	 */
	title: string;
	/**
	 * @minLength 1
	 * @maxLength 4096
	 */
	message: string;
}

export interface CreateUserFeedbackRequestV1 {
	title: string;
	message: string;
}

export enum PromoTypeV1 {
	ThreeDaysOneRub = 'three_days_one_rub',
	ThirtyDaysOneRub = 'thirty_days_one_rub',
}

export interface GetPromoCodeResponseV1 {
	type: PromoTypeV1;
}

export interface ValidatePromoCode400ResponseV1 {
	message: 'promo_code_expired';
}

export interface ResourceNotFound404ResponseV1 {
	message: 'requested_resource_not_found';
}

export interface PostProblemAlgorithmsTemplatesRequestV1 {
	/**
	 * Имя функции, которое должно быть использовано во всех шаблонах
	 * @example "build_report"
	 */
	functionName: string;
	/**
	 * Входные параметры функции (порядок важен)
	 * @minItems 0
	 */
	testInputTypes: TestInputType[];
	testOutputType: TestOutputType;
}

export interface ProblemCodeGenStateResponseV1 {
	/**
	 * Имя функции, которое должно быть использовано во всех шаблонах
	 * @example "build_report"
	 */
	functionName: string;
	/**
	 * Входные параметры функции (порядок важен)
	 * @minItems 0
	 */
	testInputTypes: TestInputType[];
	testOutputType: TestOutputType;
}

/** @example [{"type":"array<int>","name":"ages"},{"type":"array<array<int>>","name":"stats"}] */
export interface TestInputType {
	/**
	 * Тип аргумента в нотации платформы (строка, **не** enum).
	 * Примеры: "int", "array<int>", "array<array<int>>", "string"
	 */
	type: string;
	/** Имя аргумента */
	name: string;
}

/** @example {"type":"array<int>"} */
export interface TestOutputType {
	/**
	 * Тип возвращаемого значения в нотации платформы (строка, **не** enum).
	 * Примеры: "int", "array<int>", "array<array<int>>", "string"
	 */
	type: string;
}

export interface PostProblemClassAlgorithmsTemplatesRequestV1 {
	/**
	 * Имя класса в snake_case
	 * @example "linked_list"
	 */
	className: string;
	constructor: ClassConstructorV1;
	/**
	 * Методы класса
	 * @minItems 1
	 */
	functions: ClassFunctionV1[];
}

export interface ProblemClassAlgorithmsCodeGenStateResponseV1 {
	/**
	 * Имя класса в snake_case
	 * @example "linked_list"
	 */
	className: string;
	constructor: ClassConstructorV1;
	/**
	 * Методы класса
	 * @minItems 1
	 */
	functions: ClassFunctionV1[];
}

export interface ClassConstructorV1 {
	inputTypes: TestInputType[];
}

export interface ClassFunctionV1 {
	/** @example "add" */
	functionName: string;
	inputTypes: TestInputType[];
	outputType: ClassOutputTypeV1;
}

export interface ClassOutputTypeV1 {
	/**
	 * Тип возвращаемого значения или "void"
	 * @example "int"
	 */
	type: string;
}

export interface PostProblemS3Files400ErrorResponse {
	message: 'invalid_problem_category' | 'error_creating_problem_resources';
	details?: string;
}

export interface GrantPremiumForUserV1 {
	/**
	 * Количество дней
	 * @min 1
	 * @max 365
	 */
	days: number;
	/** Описание */
	description: string;
}

export interface UpdateAdminUserRequestV1 {
	role: UserRole;
	contentPermissionLevel?: PermissionLevelV1;
}

export interface UpdateAdminUser400Response {
	message: 'invalid_user_role' | 'invalid_permission_level';
}

export interface SecretSQLRequestV1 {
	/** SQL-запрос. Разрешён только SELECT. */
	query: string;
}

export interface SecretSQLResponseV1 {
	columns: string[];
	/** Массив строк; каждая строка — массив значений колонок (null для NULL). */
	rows: (string | null)[][];
	/** true, если результат был обрезан по лимиту строк. */
	truncated: boolean;
}

export interface SecretSQL400Response {
	message: 'only_select_allowed' | 'invalid_query';
	/** Текст ошибки выполнения запроса (для invalid_query). */
	details?: string;
}

export interface UserSearchListV1 {
	total: number;
	items: UserSearchItemV1[];
}

export interface UserSearchItemV1 {
	userInfo: UserInfoV1;
	telegramInfo?: UserTelegramInfoV1;
	subscriptionInfo?: UserSubscriptionInfoV1;
}

export interface UserInfoV1 {
	userID: string;
	userLogin: string;
	email: string;
	role: UserRole;
	/** @format date-time */
	createdAt: string;
	contentPermissionLevel?: PermissionLevelV1;
}

export interface UserTelegramInfoV1 {
	/** @format int64 */
	id: number;
	userName?: string;
	firstName: string;
	lastName?: string;
}

export interface UserSubscriptionInfoV1 {
	subscriptionId: string;
	accessTier: string;
	/** @format date-time */
	expirationDate: string;
}

export interface UserSubscriptionAuditListV1 {
	total: number;
	items: UserSubscriptionAuditItemV1[];
}

export interface UserSubscriptionAuditItemV1 {
	action: string;
	name: string;
	description?: string;
	subscriptionId: string;
	/** @format date-time */
	createdAt: string;
	relatedPayment?: AuditRelatedPaymentV1;
}

export interface AuditRelatedPaymentV1 {
	paymentId: string;
	/** @format int64 */
	amount: number;
	providerId: ProviderId;
	paymentType: PaymentTypeV1;
	promoCode?: string;
}

export enum PaymentTypeV1 {
	Parent = 'parent',
	Single = 'single',
	Recurrent = 'recurrent',
}

export interface GrantPremiumDetailedErrorResponseV1 {
	message: 'failed_to_grant_premium';
	details: string;
}

export enum SystemNotificationStatusV1 {
	Archived = 'archived',
	Active = 'active',
	Draft = 'draft',
}

export enum SystemNotificationLevelV1 {
	SystemNotificationLevelV1Warning = 'warning',
	SystemNotificationLevelV1Error = 'error',
	SystemNotificationLevelV1Info = 'info',
	SystemNotificationLevelV1Advertisement = 'advertisement',
}

export enum SystemNotificationAudienceV1 {
	SystemNotificationAudienceV1All = 'all',
	SystemNotificationAudienceV1NonAdvanced = 'non_advanced',
	SystemNotificationAudienceV1Advanced = 'advanced',
}

export interface SystemNotificationV1 {
	id: string;
	widgetTitle: string;
	title: string;
	description: string;
	level: SystemNotificationLevelV1;
	audience: SystemNotificationAudienceV1;
	/**
	 * Advertisement destination: absolute HTTP(S) URL or root-relative path. Empty uses /career-offer; omitted on update leaves the link unchanged.
	 * @maxLength 2048
	 */
	linkUrl: string;
}

export interface SystemNotificationAdminV1 {
	id: string;
	title: string;
	widgetTitle: string;
	description: string;
	level: SystemNotificationLevelV1;
	status: SystemNotificationStatusV1;
	audience: SystemNotificationAudienceV1;
	/**
	 * Advertisement destination: absolute HTTP(S) URL or root-relative path. Empty uses /career-offer; omitted on update leaves the link unchanged.
	 * @maxLength 2048
	 */
	linkUrl: string;
}

export interface SystemNotificationsListV1 {
	notifications: SystemNotificationV1[];
}

export interface SystemNotificationsAdminListV1 {
	notifications: SystemNotificationAdminV1[];
}

export interface CreateSystemNotificationRequestV1 {
	title: string;
	widgetTitle: string;
	description: string;
	level: SystemNotificationLevelV1;
	audience?: SystemNotificationAudienceV1;
	/**
	 * Advertisement destination: absolute HTTP(S) URL or root-relative path. Empty uses /career-offer; omitted on update leaves the link unchanged.
	 * @maxLength 2048
	 */
	linkUrl?: string;
}

export interface UpdateSystemNotificationRequestV1 {
	title?: string;
	widgetTitle?: string;
	description?: string;
	level?: SystemNotificationLevelV1;
	status?: SystemNotificationStatusV1;
	audience?: SystemNotificationAudienceV1;
	/**
	 * Advertisement destination: absolute HTTP(S) URL or root-relative path. Empty uses /career-offer; omitted on update leaves the link unchanged.
	 * @maxLength 2048
	 */
	linkUrl?: string;
}

export interface SystemNotification400ErrorResponseV1 {
	message: 'invalid_system_notification_link_url';
}

export interface UpdateSystemNotification409ErrorResponseV1 {
	message: 'system_notification_not_modifiable';
}

export interface AnonymousRegisterForFreeCourseV1 {
	email: string;
	unisenderListId: number;
	advertisingMail: boolean;
	utmSource?: string;
	utmMedium?: string;
	utmCampaign?: string;
	utmContent?: string;
	utmTerm?: string;
}

export interface AnonymousRegisterForFreeCourseResponseV1 {
	message: string;
}

export interface AnonymousRegisterForFreeCourse400ResponseV1 {
	message: 'email_already_exists';
}

export interface RegisterForFreeCourseV1 {
	unisenderListId: number;
	advertisingMail: boolean;
	utmSource?: string;
	utmMedium?: string;
	utmCampaign?: string;
	utmContent?: string;
	utmTerm?: string;
}

export interface RegisterForFreeCourseResponseV1 {
	message: string;
}

export interface UnsubscribeFromMailingRequestV1 {
	reason: string;
}

export interface UnsubscribeFromMailingResponseV1 {
	message: string;
}

export interface UserAlreadyHasPremiumError {
	message: 'user_already_has_premium';
}

export interface AnonymousRegisterForWebinarRequestV1 {
	email: string;
	unisenderListId: number;
	advertisingMail: boolean;
	redirectUrl: string;
	utmSource?: string;
	utmMedium?: string;
	utmCampaign?: string;
	utmContent?: string;
	utmTerm?: string;
}

export interface RegisterForWebinarRequestV1 {
	unisenderListId: number;
	advertisingMail: boolean;
	redirectUrl: string;
	utmSource?: string;
	utmMedium?: string;
	utmCampaign?: string;
	utmContent?: string;
	utmTerm?: string;
}

export interface WebinarRegistrationResponseV1 {
	webinarToken: string;
}

export interface PostCreateUserInterviewV1 {
	languageId: number;
	simulatorId: string;
}

export interface GetAllUserInterviewsResponseV1 {
	total: number;
	items: GetUserInterviewResponseV1[];
}

export interface GetUserInterviewResponseV1 {
	id: string;
	status: InterviewStatus;
	language: InterviewLanguage;
	steps?: InterviewStep[] | null;
	grade?: Grade | null;
	aiVerdict?: ContentBlockV1[] | null;
	aiProblemsReport?: ContentBlockV1[] | null;
	error?: ContentBlockV1[] | null;
}

export interface InterviewStep {
	type: 'problem' | 'page';
	id: string;
	status: 'not_started' | 'in_progress' | 'solved';
}

export enum InterviewStatus {
	InProgress = 'in_progress',
	AiGenerating = 'ai_generating',
	Completed = 'completed',
	Error = 'error',
}

export enum InterviewType {
	Algorithm = 'algorithm',
}

export enum Grade {
	NoHire = 'no_hire',
	Junior = 'junior',
	Middle = 'middle',
	Middle1 = 'middle+',
	Senior = 'senior',
}

export interface CreateUserInterviewResponseV1 {
	id: string;
}

export interface CreateUserInterview400ErrorResponse {
	message: 'interview_already_exists';
}

export interface GetInterviewSimulatorResponseV1 {
	id: string;
	title: string;
	description: SimulatorDescriptionV1;
	interviewType: InterviewType;
	languages: InterviewLanguage[];
	companyName?: string | null;
}

export interface SimulatorDescriptionV1 {
	rules: string[];
}

export interface InterviewLanguage {
	languageID: number;
	languageSlug: string;
}

export interface PostCompleteAISelectTaskV1 {
	optionId: string;
}

export interface PostSubmitAIProblemCodeTaskV1 {
	attachments: AICodeReviewAttachmentV1[];
}

export interface PostSubmitAICodeReviewTaskV1 {
	attachments: AICodeReviewAttachmentV1[];
}

export interface AICodeReviewAttachmentV1 {
	fileName: string;
	content: string;
}

export interface CompleteAITask400ResponseV1 {
	message: 'ai_interview_not_active' | 'ai_interview_wrong_task';
}

export enum AIDialogStatusV1 {
	Idle = 'idle',
	Finished = 'finished',
	Aborted = 'aborted',
	AiGenerating = 'aiGenerating',
	AiError = 'aiError',
	AiCompaction = 'aiCompaction',
	AiReport = 'aiReport',
}

export enum AIMessageRoleV1 {
	Assistant = 'assistant',
	User = 'user',
	System = 'system',
}

export enum AIAttachmentFileFormatV1 {
	Cpp = 'cpp',
	Py = 'py',
	Java = 'java',
	Go = 'go',
	Cs = 'cs',
	Js = 'js',
	Sql = 'sql',
	Json = 'json',
	Yml = 'yml',
	Md = 'md',
}

export enum AIProblemTypeV1 {
	AiTheory = 'ai-theory',
	AiPractice = 'ai-practice',
	AiInterview = 'ai-interview',
	AiAlgo = 'ai-algo',
}

export enum AIProblemTaskTypeV1 {
	Static = 'static',
	Select = 'select',
	MultiSelect = 'multi-select',
	Problem = 'problem',
	CodeReview = 'code-review',
	Discussion = 'discussion',
	Code = 'code',
	Questions = 'questions',
}

export interface AIDialogCurrentTaskV1 {
	taskId: string;
	taskType: AIProblemTaskTypeV1;
}

export enum AIInterviewAlreadyExistsErrorV1 {
	AiInterviewAlreadyExists = 'ai_interview_already_exists',
}

export enum CreateAIDialog400ErrorMessageV1 {
	AiInterviewAlreadyExists = 'ai_interview_already_exists',
	AiInterviewLanguageNotSupported = 'ai_interview_language_not_supported',
	AiInterviewLanguageRequired = 'ai_interview_language_required',
}

export enum SubmitAICode400ErrorMessageV1 {
	AiInterviewInvalidProblem = 'ai_interview_invalid_problem',
	AiInterviewNotActive = 'ai_interview_not_active',
}

export interface SubmitAICode400ErrorResponseV1 {
	message: SubmitAICode400ErrorMessageV1;
}

export interface ListAIProblemsResponseV1 {
	items: AIProblemV1[];
}

export interface AIProblemV1 {
	id: string;
	title: string;
	type: AIProblemTypeV1;
	timeLimitMinutes: number;
	languages: number[];
}

export interface GetAIProblemResponseV1 {
	tags?: ProblemTagV1[];
	id: string;
	title: string;
	type: AIProblemTypeV1;
	timeLimitMinutes: number;
	languages: number[];
	isSolved: boolean;
	activeDialogId?: string;
	permissionLevel: PermissionLevelV1;
	/** True if the problem has an ai-algo render (leetcode-style) view — i.e. a GET /v1/ai-algo-problems/{id}/content is available. The client uses it to decide whether to offer the static problem view. */
	hasStaticView: boolean;
}

/** ai-algo problem difficulty on a fixed scale: 1=easy, 2=medium, 3=hard (same scale as ProblemV1.difficulty). Used by ai-algo create/edit payloads; request validation rejects any other value with 400. The DB stores a plain INT (no CHECK/ENUM, per repo convention). */
export enum AIAlgoDifficultyV1 {
	Value1 = 1,
	Value2 = 2,
	Value3 = 3,
}

/** Leetcode-style render view for an ai-algo problem. Every text field is Markdown. Assembled from the ai_algo_problem_content_md (language-agnostic statement / video) and ai_algo_problem_language_content_md (per-language starter template + solution) render tables; decoupled from the dialog flow. */
export interface GetAIAlgoProblemContentResponseV1 {
	tags?: ProblemTagV1[];
	id: string;
	title: string;
	/** Full leetcode-style problem statement (Markdown). */
	descriptionMd: string;
	/** ai-algo-owned difficulty, stored on the content row — not derived from the backing algorithms problem. Always one of 1, 2, 3 (see AIAlgoDifficultyV1; kept a plain integer on this response so the output is not schema-validated). */
	difficulty: number;
	/** ai-algo-owned company tags (company names), stored on the ai-algo side (own join table) — not derived from the backing algorithms problem. Empty when the problem has no tags. */
	companies: string[];
	/** Optional video, as a Markdown image embed pointing at Kinescope, e.g. `![Название](https://kinescope.io/ID)`. Omitted when the problem has no video. */
	videoMd?: string;
	/** Whether the problem is available without a paid subscription. */
	isFree: boolean;
	/** Whether the problem is published (visible to users). */
	isVisible: boolean;
	permissionLevel: PermissionLevelV1;
	/** Whether the calling user has solved this problem: either they have an accepted standalone submission (ai_algo_solved) or they completed the AI dialog. Reset in bulk by clear-progress-by-course, which clears both markers. Always false in the admin edit (PATCH) response. */
	isSolved: boolean;
	languages: AIAlgoLanguageContentV1[];
}

export interface AIAlgoLanguageContentV1 {
	/** codeLanguages id (1=python, 2=cpp, 3=golang, 4=java, 5=csharp, 6=javascript). */
	languageId: number;
	/** Per-language starter template shown in the editor, as one or more files. Usually a single file named for the language (e.g. solution.go); multiple files are supported. The client echoes these file names back when submitting or saving a sandbox draft. */
	starterFiles: AIAlgoFileV1[];
	/** Optional per-language reference solution — a complete, ready-to-render Markdown page including the approach and time/memory complexity. Kept per language. Omitted when not authored. */
	solutionMd?: string;
	/** Human-readable runtime version for this language (e.g. "3.14.3", "go1.25.6"), from a static backend map. Omitted for languages that have no configured version. */
	version?: string;
}

export interface CreateAdminAIAlgoProblemRequestV1 {
	/**
	 * @minLength 1
	 * @maxLength 50
	 */
	id: string;
	title: string;
	/** ai-algo problem difficulty on a fixed scale: 1=easy, 2=medium, 3=hard (same scale as ProblemV1.difficulty). Used by ai-algo create/edit payloads; request validation rejects any other value with 400. The DB stores a plain INT (no CHECK/ENUM, per repo convention). */
	difficulty: AIAlgoDifficultyV1;
	descriptionMd: string;
	videoMd?: string;
	companies: string[];
	isFree: boolean;
	/** Create-only migration endpoint always creates a hidden problem. */
	isVisible: false;
	permissionLevel: PermissionLevelV1;
	execution: CreateAdminAIAlgoExecutionV1;
	/** @minItems 1 */
	languages: CreateAdminAIAlgoLanguageV1[];
	interviewGuidance: CreateAdminAIAlgoInterviewGuidanceV1;
}

export interface CreateAdminAIAlgoInterviewGuidanceV1 {
	discussion: CreateAdminAIAlgoDiscussionGuidanceV1;
	code: CreateAdminAIAlgoCodeGuidanceV1;
}

export interface CreateAdminAIAlgoDiscussionGuidanceV1 {
	/**
	 * Exactly two ordered criteria; the first starts with "Идея решения:", the second with "Сложность:".
	 * @maxItems 2
	 * @minItems 2
	 */
	dod: string[];
	/** @minItems 1 */
	commonHints: string[];
	byLanguage: Record<string, CreateAdminAIAlgoLanguageGuidanceV1>;
	/**
	 * Full hidden discussion material; starts with unchanged descriptionMd and appends generated clarification facts.
	 * @minLength 1
	 */
	referenceMaterial: string;
}

export interface CreateAdminAIAlgoCodeGuidanceV1 {
	/** @minItems 3 */
	dod: string[];
	/** @minItems 1 */
	commonHints: string[];
	byLanguage: Record<string, CreateAdminAIAlgoLanguageGuidanceV1>;
}

export interface CreateAdminAIAlgoLanguageGuidanceV1 {
	/** @minItems 1 */
	additionalDod?: string[];
	/** @minItems 1 */
	additionalCommonHints?: string[];
}

export interface CreateAdminAIAlgoExecutionV1 {
	/**
	 * @minLength 1
	 * @maxLength 50
	 */
	id: string;
	fixturePrefix: string;
	handlingType: string;
}

export interface CreateAdminAIAlgoLanguageV1 {
	languageId: number;
	starterFiles: AIAlgoCodeFileV1[];
	solutionMd?: string;
}

export interface CreateAdminAIAlgoProblem409ResponseV1 {
	message: 'ai_algo_problem_already_exists';
}

/** Edits an ai-algo problem's authored content: statement / video, the per-language reference solutions, and the per-language starter templates. Each solution is a display page that must contain exactly one fenced code block; that block is run against the backing problem's tests and the save is rejected unless it passes. solutions fully replace the stored solution set (a language omitted here has its solution cleared). Solutions cannot be changed once the problem is visible. starterFiles hand-authors the multi-file starter shown in the editor; a language set here is marked manually authored and is from then on skipped by template regeneration, so the edit is not silently reverted the next time fixtures are generated. */
export interface UpdateAdminAIAlgoContentRequestV1 {
	title: string;
	/** Full leetcode-style problem statement (Markdown). */
	descriptionMd: string;
	/** ai-algo problem difficulty on a fixed scale: 1=easy, 2=medium, 3=hard (same scale as ProblemV1.difficulty). Used by ai-algo create/edit payloads; request validation rejects any other value with 400. The DB stores a plain INT (no CHECK/ENUM, per repo convention). */
	difficulty: AIAlgoDifficultyV1;
	/** Optional video as a Markdown image embed, e.g. `![Название](https://kinescope.io/ID)`. Omit to leave the stored video unchanged; send an empty string to clear it. */
	videoMd?: string;
	/** Company tags (company names). Omit to leave the stored tags unchanged; provide (including an empty array) to fully replace the set. Unknown names are registered into the shared company vocabulary. */
	companies?: string[];
	/** Optional. When omitted, the stored solutions are left unchanged. When provided, it fully replaces the solution set — a language not present has its stored solution cleared, and each solutionMd must contain exactly one fenced code block, run and verified against the backing tests. Send an empty array to clear all solutions. */
	solutions?: UpdateAdminAIAlgoSolutionV1[];
	/** Optional. When omitted, the stored starter templates are left untouched (including their codegen-owned / manually-authored marking). When provided, every language listed has its starter template replaced by the given files and is marked manually authored, which makes template regeneration skip it from then on. Languages NOT listed are left as they are — this is a per-language patch, not a full replacement, because the unlisted languages are normally codegen-owned and clearing them would leave the editor empty. File names must be unique and non-empty; content is base64-encoded. */
	starterFiles?: UpdateAdminAIAlgoStarterFilesV1[];
}

export interface UpdateAdminAIAlgoStarterFilesV1 {
	/** codeLanguages id (1=python, 2=cpp, 3=golang, 4=java, 5=csharp, 6=javascript). */
	languageId: number;
	/** The multi-file starter template for this language, replacing whatever is stored. An empty array is allowed and means "this language opens with no starter file". */
	files: AIAlgoCodeFileV1[];
}

export interface UpdateAdminAIAlgoSolutionV1 {
	/** codeLanguages id (1=python, 2=cpp, 3=golang, 4=java, 5=csharp, 6=javascript). */
	languageId: number;
	/** Reference solution as a Markdown display page. Must contain exactly one fenced code block (the runnable solution), which must define the harness entry point and pass the backing tests. */
	solutionMd: string;
}

/** Спека генерации шаблонов для ai-algo execution — одна схема на обе формы задачи, выбираемая полем `kind`. `function` — обычная алго-задача (сигнатура одной функции); `class` — задача с классом (конструктор + методы). Это ровно то, что раньше было разнесено по двум ручкам /v1/problems/{problemID}/algorithms-templates и .../class-algorithms-templates; те ручки остаются как есть и работают с `problems`, а эта — с ai-algo фикстурами. Одна и та же схема используется и как тело POST, и как ответ GET .../code-gen-state. */
export type AIAlgoTemplatesSpecV1 =
	| ({
			kind: 'function';
	  } & AIAlgoFunctionTemplatesSpecV1)
	| ({
			kind: 'class';
	  } & AIAlgoClassTemplatesSpecV1);

/** Задача-функция — то же тело, что у PostProblemAlgorithmsTemplatesRequestV1, плюс `kind`. */
export interface AIAlgoFunctionTemplatesSpecV1 {
	kind: 'function';
	/**
	 * Имя функции, которое должно быть использовано во всех шаблонах
	 * @example "build_report"
	 */
	functionName: string;
	/**
	 * Входные параметры функции (порядок важен)
	 * @minItems 0
	 */
	testInputTypes: TestInputType[];
	testOutputType: TestOutputType;
}

/** Задача с классом — то же тело, что у PostProblemClassAlgorithmsTemplatesRequestV1, плюс `kind`. */
export interface AIAlgoClassTemplatesSpecV1 {
	kind: 'class';
	/**
	 * Имя класса в snake_case
	 * @example "linked_list"
	 */
	className: string;
	constructor: ClassConstructorV1;
	/**
	 * Методы класса
	 * @minItems 1
	 */
	functions: ClassFunctionV1[];
}

/** Объекты, из которых состоит набор фикстур: по архиву шаблона на язык плюс тесты. Пустой массив — валидный ответ (execution заведён, но шаблоны ещё не сгенерированы и ничего не загружено). */
export type GetAIAlgoExecutionFilesResponseV1 = AIAlgoExecutionFileInfoV1[];

export interface AIAlgoExecutionFileInfoV1 {
	/** Имя объекта — то, что принимают GET/PUT .../files/{fileName}: `{язык}.zip` или `tests.json`. */
	name: string;
	/** Полный s3-ключ. Обычно это `{префикс}/{name}`, но у тестов может быть иначе — когда execution переиспользует чужие архивы шаблонов со своими тестами, объект тестов лежит вне папки. Поле показывает, что именно читается. */
	key: string;
	/** @format int64 */
	size: number;
	/** @format date-time */
	lastModified: string;
	/** codeLanguages id для архива шаблона; отсутствует у tests.json. */
	languageId?: number;
	eTag?: string;
}

export interface AIAlgoExecutionFile400ResponseV1 {
	message: 'ai_algo_unknown_fixture_file' | 'dirty_version';
}

export interface AIAlgoTemplates400ResponseV1 {
	message: 'ai_algo_templates_spec_invalid';
}

export interface AIAlgoTemplates422ResponseV1 {
	message: 'cannot_update_visible_ai_algo_execution';
}

export interface UpdateAdminAIAlgoContent400ResponseV1 {
	message:
		| 'ai_algo_content_invalid'
		| 'ai_algo_solution_no_code_block'
		| 'ai_algo_solution_multiple_code_blocks'
		| 'ai_algo_invalid_files';
}

export interface UpdateAdminAIAlgoContent422ResponseV1 {
	message:
		| 'ai_algo_solution_execution_failed'
		| 'cannot_update_solution_for_visible_problem';
}

/** One file of a multi-file bundle (a starter template, a submission, or a sandbox draft), returned to the client. Content is plain UTF-8 text, ready to render in the editor. */
export interface AIAlgoFileV1 {
	/** File name including extension, e.g. "solution.go". For the entry file it matches the name the execution harness expects for the language. */
	fileName: string;
	/** File content (plain UTF-8 text). */
	content: string;
}

/** One file sent by the client (a submission file or a sandbox-draft file). Content is base64-encoded so any bytes survive JSON transport. */
export interface AIAlgoCodeFileV1 {
	/** File name including extension, e.g. "solution.go". */
	fileName: string;
	/** Base64-encoded file content. */
	base64Content: string;
}

export interface SubmitAIAlgoCodeRequestV1 {
	/** codeLanguages id; must be one of the problem's languages. */
	languageId: number;
	/**
	 * The submitted solution as one or more files. Usually a single file whose name matches the language's starter template (e.g. solution.go); multiple files are supported.
	 * @minItems 1
	 */
	files: AIAlgoCodeFileV1[];
}

export interface UpdateAIAlgoSandboxRequestV1 {
	/** codeLanguages id; must be one of the problem's languages. */
	languageId: number;
	/** The draft files to save for this language. Fully replaces any previously saved draft for the (user, problem, language). An empty array clears the draft. */
	files: AIAlgoCodeFileV1[];
}

/** The caller's saved working draft for one ai-algo problem+language. */
export interface AIAlgoSandboxV1 {
	languageId: number;
	files: AIAlgoFileV1[];
}

export interface GetAIAlgoSandboxResponseV1 {
	/** One entry per language for which the caller has a saved draft. */
	items: AIAlgoSandboxV1[];
}

/** One ai-algo submission with its structured run result and submitted files. */
export interface AIAlgoSubmissionV1 {
	submissionId: string;
	/** Lifecycle status. `processing` while the run is in flight (result absent); then the normalized verdict / run status (e.g. accepted, wrong_answer, runtime_error, success) or internal_error. */
	status: string;
	languageId: number;
	/** Structured run result the client renders. Absent while status is `processing` (or when the run could not complete). */
	result?: AIAlgoRunResultV1;
	/** The submitted source as one or more files. */
	files: AIAlgoFileV1[];
	/** @format date-time */
	submittedAt: string;
}

/** Structured result of running a submission — the state the client renders (no server-side Markdown). A oneOf selected by `type`: one variant per verdict for algorithm-handling runs (accepted / wrong_answer / bad_return_type / runtime_error / compile_error / time_limit / memory_limit / internal_error), plus a `raw` variant for advanced-handling runs (program stdout/stderr). `verdict` is the normalized verdict on every variant and matches the submission status — note that `bad_return_type` is a distinct RENDERING of the `wrong_answer` verdict, not a verdict of its own, so its `verdict` reads `wrong_answer`. */
export type AIAlgoRunResultV1 =
	| ({
			type: 'accepted';
	  } & AIAlgoAcceptedResultV1)
	| ({
			type: 'wrong_answer';
	  } & AIAlgoWrongAnswerResultV1)
	| ({
			type: 'bad_return_type';
	  } & AIAlgoBadReturnTypeResultV1)
	| ({
			type: 'runtime_error';
	  } & AIAlgoRuntimeErrorResultV1)
	| ({
			type: 'compile_error';
	  } & AIAlgoCompileErrorResultV1)
	| ({
			type: 'time_limit';
	  } & AIAlgoTimeLimitResultV1)
	| ({
			type: 'memory_limit';
	  } & AIAlgoMemoryLimitResultV1)
	| ({
			type: 'internal_error';
	  } & AIAlgoInternalErrorResultV1)
	| ({
			type: 'raw';
	  } & AIAlgoRawResultV1);

/** All tests passed (algorithm handling). */
export interface AIAlgoAcceptedResultV1 {
	type: 'accepted';
	/** Normalized verdict; matches the submission status. */
	verdict: string;
}

/** A test failed — the failing test's input and the expected vs actual output. */
export interface AIAlgoWrongAnswerResultV1 {
	type: 'wrong_answer';
	verdict: string;
	/** Failing test input (omitted when hidden). */
	input?: string;
	/** Expected output. */
	expected?: string;
	/** Actual program output. */
	actual?: string;
	/** Extra detail about the failure, when the harness gave any. Present for failures that a plain expected-vs-actual comparison cannot explain on its own. */
	message?: string;
}

/** The solution returned a value of the wrong TYPE, so its output was never comparable — reported by the harness in the dynamically typed languages (Python, JavaScript). It carries the `wrong_answer` verdict but renders differently: the useful fact is the type mismatch, not the output. */
export interface AIAlgoBadReturnTypeResultV1 {
	type: 'bad_return_type';
	/** Normalized verdict; reads `wrong_answer` — this is a rendering, not a verdict. */
	verdict: string;
	/** Failing test input (omitted when hidden). */
	input?: string;
	/** The type the problem expects, e.g. "bool". */
	expectedType?: string;
	/** The type the solution returned, e.g. "str". */
	actualType?: string;
	/** Human-readable summary of the mismatch. */
	message?: string;
}

/** The program crashed on a test — the failing input and the crash output. */
export interface AIAlgoRuntimeErrorResultV1 {
	type: 'runtime_error';
	verdict: string;
	/** Failing test input (omitted when hidden). */
	input?: string;
	/** Exception / traceback / crash stderr. */
	message?: string;
}

/** The submission failed to compile. */
export interface AIAlgoCompileErrorResultV1 {
	type: 'compile_error';
	verdict: string;
	/** Compiler error output. */
	message?: string;
}

/** The program exceeded the time limit. */
export interface AIAlgoTimeLimitResultV1 {
	type: 'time_limit';
	verdict: string;
	/** Failing test input (omitted when hidden). */
	input?: string;
}

/** The program exceeded the memory limit. */
export interface AIAlgoMemoryLimitResultV1 {
	type: 'memory_limit';
	verdict: string;
	/** Failing test input (omitted when hidden). */
	input?: string;
}

/** The check could not be completed (infrastructure / system error). */
export interface AIAlgoInternalErrorResultV1 {
	type: 'internal_error';
	verdict: string;
	/** Diagnostic message, when available. */
	message?: string;
}

/** Advanced / raw-handling run — the normalized verdict plus the program's stdout/stderr. */
export interface AIAlgoRawResultV1 {
	type: 'raw';
	/** Normalized verdict (accepted, runtime_error, …); matches the submission status. */
	verdict: string;
	/** Raw run stdout. */
	stdout?: string;
	/** Raw run stderr. */
	stderr?: string;
}

/** A submission row for the paginated history (no verdict body / code). */
export interface AIAlgoSubmissionSummaryV1 {
	submissionId: string;
	/** Lifecycle status (`processing` while running, else the terminal verdict / run status). */
	status: string;
	languageId: number;
	/** @format date-time */
	submittedAt: string;
}

export interface ListAIAlgoSubmissionsResponseV1 {
	/** Total submissions for this user + problem across all pages. */
	total: number;
	items: AIAlgoSubmissionSummaryV1[];
}

export interface GetAdminAIProblemResponseV1 {
	tags?: ProblemTagV1[];
	/** @min 0 */
	tags_version?: number;
	id: string;
	title: string;
	type: AIProblemTypeV1;
	timeLimitMinutes: number;
	languages: number[];
	permissionLevel: PermissionLevelV1;
	isFree: boolean;
	isVisible: boolean;
	selfReviewEnabled: boolean;
	reportPrompt?: string;
	/** Complete Markdown references including code, keyed by golang, python, java, cpp, csharp, javascript or postgresql. Reports require a nonblank entry for the attempt language. */
	referenceSolutionByLanguage?: Record<string, string>;
	completionMessage?: AdminAIMessageV1;
	tasks: AdminAIProblemTaskV1[];
}

export interface AdminAIProblemTaskV1 {
	id: string;
	type: AIProblemTaskTypeV1;
	initialMessage: AdminAIMessageV1;
	/** Raw type-specific config JSON from the ai_problem_task.config column, returned verbatim (including server-side fields such as correctOptionId, referenceSolutions and question answers). Shape depends on the task type. */
	config?: Record<string, any>;
}

export interface AdminAIMessageV1 {
	id: number;
	role: string;
	content: string;
	attachments?: AdminAIAttachmentV1[];
	/** Optional per-language opener overrides keyed by language slug (python, cpp, golang, java, csharp, javascript). Only meaningful on a code / discussion task's initialMessage. Each entry's non-empty fields override the base message for the dialog's chosen language; the rest are inherited. Empty / omitted means the base message is used for every language. */
	byLanguage?: Record<string, AdminAIMessageOverrideV1>;
}

/** Per-language override for a code / discussion task's opener, selected by the dialog's language slug. Only the fields set here replace the base message for that language; the rest (and never a nested byLanguage) are inherited. */
export interface AdminAIMessageOverrideV1 {
	content?: string;
	attachments?: AdminAIAttachmentV1[];
}

export interface AdminAIAttachmentV1 {
	fileName: string;
	content: string;
	problemId?: string;
	helperText?: string;
	config?: Record<string, any>;
}

/** Same shape as GetAdminAIProblemResponseV1 (minus the problem id, which comes from the path). tasks are matched to existing tasks by id; type/config/initialMessage are updated in place. */
export interface UpdateAdminAIProblemRequestV1 {
	title: string;
	type: AIProblemTypeV1;
	timeLimitMinutes: number;
	languages: number[];
	permissionLevel: PermissionLevelV1;
	isFree: boolean;
	isVisible: boolean;
	selfReviewEnabled: boolean;
	reportPrompt?: string;
	/** Partial map of complete Markdown references keyed by golang, python, java, cpp, csharp, javascript or postgresql. Omitted languages are preserved; null deletes a language; blank strings disable its report. */
	referenceSolutionByLanguage?: Record<string, string | null>;
	completionMessage?: AdminAIMessageV1;
	tasks: AdminAIProblemTaskV1[];
}

export interface UpdateAdminAIProblem400ResponseV1 {
	message: 'ai_problem_invalid';
}

export interface CreateAIDialogV1 {
	aiProblemId: string;
	languageId?: number;
}

export interface CreateAdminAIProblemRequestV1 {
	type: AIProblemTypeV1;
	/** Текстовое описание проблемы. ИИ по нему спланирует и сформирует набор ai_problem_task (config + initial_message) и обёртку ai_problem. Поддерживаются типы ai-theory и ai-practice. Для ai-practice ИИ определяет язык материала и формирует последовательность задач. */
	prompt: string;
}

export interface CreateAdminAIProblemResponseV1 {
	/** Идентификатор события в aiOutbox для отслеживания генерации. */
	outboxId: string;
}

export interface CreateAdminAIProblem400ResponseV1 {
	message: 'ai_problem_invalid';
}

export enum AIDialogStatusUpdateV1 {
	Aborted = 'aborted',
	AiReport = 'aiReport',
}

export interface UpdateAIDialogStatusRequestV1 {
	status: AIDialogStatusUpdateV1;
}

export interface UpdateAIDialogStatus400Response {
	message: 'ai_interview_not_active';
}

export interface CreateAIDialogResponseV1 {
	dialogId: string;
}

export interface CreateAIDialog400ErrorResponseV1 {
	message: CreateAIDialog400ErrorMessageV1;
}

export interface GetAIDialogResponseV1 {
	id: string;
	interviewId: string;
	status: AIDialogStatusV1;
	/** @format date-time */
	deadlineAt?: string;
	currentTask?: AIDialogCurrentTaskV1;
}

export interface ListAIDialogsResponseV1 {
	total: number;
	items: GetAIDialogResponseV1[];
}

export interface PostSendAIDialogMessageV1 {
	text: string;
	/** Optional files carried with the message (e.g. the candidate's current code for a `code` task). For a `code` task, sending text "/submit" with these attachments runs the program; any other text is treated as a question about the attached code. */
	attachments?: AICodeReviewAttachmentV1[];
}

export interface AIAttachmentSelectConfigV1 {
	options: AISelectTaskOptionV1[];
}

export interface AISelectTaskOptionV1 {
	id: string;
	text: string;
}

export interface AIAttachmentV1 {
	fileName: string;
	content: string;
	fileFormat?: AIAttachmentFileFormatV1;
	helperText?: string;
	problemId?: string;
	config?: AIAttachmentSelectConfigV1;
}

export interface AIVisibleMessageV1 {
	id: number;
	role: AIMessageRoleV1;
	content: string;
	attachments?: AIAttachmentV1[];
	/** @format date-time */
	createdAt: string;
}

export interface GetAIDialogMessagesResponseV1 {
	messages: AIVisibleMessageV1[];
}

export interface PostSubmitAIDialogCodeV1 {
	files: AIAttachmentV1[];
}

export interface CreateAISubmitResponseV1 {
	messageId: number;
}

export interface InternalVerifyCredentialsRequestV1 {
	login: string;
	/** @format password */
	password: string;
}

export interface InternalVerifyCredentialsResponseV1 {
	user_id: string;
	login: string;
	roles: string[];
	status: string;
	auth_version: number;
}

export interface InternalCompanyV1 {
	/**
	 * @minLength 1
	 * @maxLength 128
	 */
	id: string;
	/**
	 * @minLength 1
	 * @maxLength 256
	 */
	name: string;
}

export interface InternalCompanyListResponseV1 {
	items: InternalCompanyV1[];
	/** @min 0 */
	offset: number;
	/**
	 * @min 1
	 * @max 100
	 */
	limit: number;
	/** @min 0 */
	total: number;
}

export interface InternalCompanyCreateRequestV1 {
	/**
	 * @minLength 1
	 * @maxLength 128
	 * @pattern ^[a-z0-9]+(?:[_-][a-z0-9]+)*$
	 */
	id: string;
	/**
	 * @minLength 1
	 * @maxLength 256
	 */
	name: string;
}

export interface InternalCompanyPatchRequestV1 {
	/**
	 * @minLength 1
	 * @maxLength 256
	 */
	name: string;
}

export interface InternalProblemUpdateRequestV1 {
	/**
	 * @maxItems 100
	 * @uniqueItems true
	 */
	companies: string[];
}

export interface InternalProblemCompaniesResponseV1 {
	problem_id: string;
	companies: InternalCompanyV1[];
}

export enum ContentSearchTypeV1 {
	ContentSearchProblem = 'problem',
	ContentSearchTheory = 'theory',
	ContentSearchAIAlgo = 'ai-algo',
	ContentSearchAITheory = 'ai-theory',
	ContentSearchAIPractice = 'ai-practice',
	ContentSearchAIInterview = 'ai-interview',
}

export interface ContentSearchResponseV1 {
	items: ContentSearchItemV1[];
	/** @min 0 */
	total: number;
	/** @min 0 */
	offset: number;
	/**
	 * @min 1
	 * @max 100
	 */
	limit: number;
}

export interface ContentSearchItemV1 {
	id: string;
	type: ContentSearchTypeV1;
	title: string;
	is_visible: boolean;
	is_free: boolean;
	tags: ProblemTagV1[];
	course_usages: InternalProblemCourseUsageV1[];
}

export interface InternalProblemListResponseV1 {
	items: InternalProblemSummaryV1[];
	/** @min 0 */
	offset: number;
	/**
	 * @min 1
	 * @max 100
	 */
	limit: number;
	/** @min 0 */
	total: number;
}

export interface InternalProblemSummaryV1 {
	id: string;
	title: string;
	category: ProblemCategoryEnum;
	is_visible: boolean;
	is_free: boolean;
	course_usages: InternalProblemCourseUsageV1[];
}

export interface InternalProblemCourseUsageV1 {
	course_id: string;
	course_title: string;
}

export enum InternalProblemHandlingTypeV1 {
	Unknowm = 'unknowm',
	Algorithm = 'algorithm',
	AlgorithmsV2 = 'algorithms-v2',
	ClassAlgorithms = 'class-algorithms',
	Problem = 'problem',
	PgSqlSelect = 'pg_sql_select',
	JavaAdvanced = 'java-advanced',
	PythonAdvanced = 'python-advanced',
	CppAdvanced = 'cpp-advanced',
	GolangAdvanced = 'golang-advanced',
}

export interface InternalProblemDetailV1 {
	id: string;
	title: string;
	category: ProblemCategoryEnum;
	difficulty: number;
	/** @format int64 */
	correct_submissions_count: number;
	/** @format int64 */
	failure_submissions_count: number;
	/** @format date-time */
	created_at: string;
	description_prompt: ContentBlockV1[];
	is_visible: boolean;
	is_free: boolean;
	is_new: boolean;
	companies: InternalCompanyV1[];
	course_usages: InternalProblemCourseUsageV1[];
	/** @format float */
	max_wall_time_limit_seconds: number;
	max_memory_kilobytes: number;
	max_stack_frames_count: number;
	has_video: boolean;
	has_tests: boolean;
	version: number;
	handling_type: InternalProblemHandlingTypeV1;
	permission_level: PermissionLevelV1;
	editor?: InternalProblemEditorV1;
}

export interface InternalProblemEditorV1 {
	kind: 'classic' | 'ai_algo';
	description_prompt: any[] | null;
	solution_prompt: any[] | null;
	/** Classical problem video. Null when absent or for an AI problem. */
	video: {
		kinescope_video_id: string;
	} | null;
	resources:
		| {
				language_id: number;
				language_slug: string;
				template_code: string;
		  }[]
		| null;
	template: {
		kind: 'function' | 'class';
		function_name?: string;
		test_input_types?: {
			name: string;
			type: string;
		}[];
		test_output_type?: {
			type: string;
		};
	} | null;
	/** @pattern ^sha256:[0-9a-f]{64}$ */
	fixture_revision: string | null;
	tests_state: 'present' | 'missing' | 'unavailable' | 'not_applicable';
	linked_ai_problem_ids: string[];
	validation_warnings: {
		field: string;
		code: string;
	}[];
	capabilities: {
		metadata_update: InternalProblemCapabilityV1;
		content_update: InternalProblemCapabilityV1;
		solutions_check: InternalProblemCapabilityV1;
		template_update: InternalProblemCapabilityV1;
	};
}

export interface InternalProblemCapabilityV1 {
	allowed: boolean;
	reasons: string[];
}

export interface InternalProblemPatchRequestV1 {
	/** @min 1 */
	expected_version: number;
	patch: {
		/**
		 * @minLength 1
		 * @maxLength 255
		 */
		title?: string;
		difficulty?: 1 | 2 | 3;
		is_visible?: boolean;
		is_free?: boolean;
		is_new?: boolean;
		permission_level?: PermissionLevelV1;
		/** Replaces the classical problem video and synchronizes has_video. An empty ID clears the video. Omission preserves the video. Allowed for visible problems. */
		video?: {
			/** Trimmed before validation. Must be empty (clear) or match ^[A-Za-z0-9_-]{1,512}$. URLs are not accepted. */
			kinescope_video_id: string;
		};
		/** @maxItems 1000 */
		description_prompt?: Record<string, any>[];
		/** @maxItems 1000 */
		solution_prompt?: Record<string, any>[];
		/**
		 * @maxItems 100
		 * @uniqueItems true
		 */
		company_ids?: string[];
		/** @maxItems 10 */
		resources?: InternalProblemStarterV1[];
	};
}

export interface InternalProblemStarterV1 {
	/** @min 1 */
	language_id: number;
	/** @maxLength 3072 */
	template_code: string;
}

export interface InternalProblemWriteResultV1 {
	problem_id: string;
	previous_version: number;
	version: number;
	updated_fields: string[];
}

export interface InternalProblemSolutionsCheckRequestV1 {
	/** @min 1 */
	expected_version: number;
	/**
	 * @maxItems 6
	 * @minItems 1
	 */
	solutions?: {
		language_id: 1 | 2 | 3 | 4 | 5 | 6;
		/**
		 * @minLength 1
		 * @maxLength 524288
		 */
		code: string;
	}[];
}

export interface InternalProblemSolutionsCheckResultV1 {
	problem_id: string;
	version: number;
	source: 'saved' | 'draft';
	fixture_revision: string | null;
	snapshot_stale: boolean;
	complete: boolean;
	all_passed: boolean;
	results: InternalProblemSolutionResultV1[];
	warnings: {
		code: string;
		message: string;
	}[];
}

export interface InternalProblemSolutionResultV1 {
	language_id: number;
	language_slug: string;
	status:
		| 'accepted'
		| 'wrong_answer'
		| 'compilation_error'
		| 'runtime_error'
		| 'time_limit_exceeded'
		| 'memory_limit_exceeded'
		| 'execution_error'
		| 'missing_solution'
		| 'unsupported_language'
		| 'not_run';
	/** @format int64 */
	duration_ms: number | null;
	message: string | null;
	diagnostics: {
		/** @maxLength 8192 */
		compile_output: string | null;
		/** @maxLength 8192 */
		run_output: string | null;
		truncated: boolean;
		failed_test: {
			/** @maxLength 8192 */
			input: string | null;
			/** @maxLength 8192 */
			expected: string | null;
			/** @maxLength 8192 */
			actual: string | null;
		};
	};
}

export interface InternalProblemTemplateArgumentV1 {
	/**
	 * @minLength 1
	 * @maxLength 64
	 * @pattern ^[a-z][a-z0-9_]*$
	 */
	name: string;
	/**
	 * @minLength 1
	 * @maxLength 256
	 */
	type: string;
}

export interface InternalProblemTemplateOutputV1 {
	/**
	 * @minLength 1
	 * @maxLength 256
	 */
	type: string;
}

export interface InternalAIAlgoTestsAffectedProblemV1 {
	kind: 'classic' | 'ai';
	problem_id: string;
}

export interface InternalAIAlgoTemplateSnapshotV1 {
	/**
	 * @minLength 1
	 * @maxLength 50
	 */
	ai_problem_id: string;
	/**
	 * @minLength 1
	 * @maxLength 50
	 */
	execution_id: string;
	available_execution_ids: string[];
	/** @pattern ^sha256:[0-9a-f]{64}$ */
	revision: string;
	state: 'present' | 'missing';
	template: InternalProblemFunctionTemplateV1 | null;
	manual_starters: InternalAIAlgoTemplateStarterV1[];
	shared: boolean;
	affected_problems: InternalAIAlgoTestsAffectedProblemV1[];
	affected_execution_ids: string[];
}

export interface InternalAIAlgoTemplateUpdateRequestV1 {
	/**
	 * @minLength 1
	 * @maxLength 50
	 */
	execution_id: string;
	/** @pattern ^sha256:[0-9a-f]{64}$ */
	expected_revision: string;
	allow_shared?: boolean;
	template: InternalProblemFunctionTemplateV1;
}

export interface InternalAIAlgoTemplateUpdateResultV1 {
	/**
	 * @minLength 1
	 * @maxLength 50
	 */
	ai_problem_id: string;
	/**
	 * @minLength 1
	 * @maxLength 50
	 */
	execution_id: string;
	/** @pattern ^sha256:[0-9a-f]{64}$ */
	previous_revision: string;
	/** @pattern ^sha256:[0-9a-f]{64}$ */
	revision: string;
	updated_language_ids: number[];
	updated_starters: InternalAIAlgoTemplateStarterV1[];
	preserved_manual_starters: InternalAIAlgoTemplateStarterV1[];
	solutions_checked: false;
	shared: boolean;
	affected_problems: InternalAIAlgoTestsAffectedProblemV1[];
	affected_execution_ids: string[];
}

export interface InternalAIAlgoTemplateStarterV1 {
	ai_problem_id: string;
	language_id: number;
}

export interface InternalAIAlgoTestsSnapshotV1 {
	/**
	 * @minLength 1
	 * @maxLength 50
	 */
	ai_problem_id: string;
	/**
	 * @minLength 1
	 * @maxLength 50
	 */
	execution_id: string;
	available_execution_ids: string[];
	/** @pattern ^sha256:[0-9a-f]{64}$ */
	revision: string;
	state: 'present' | 'missing';
	tests: Record<string, any>;
	shared: boolean;
	affected_problems: InternalAIAlgoTestsAffectedProblemV1[];
	affected_execution_ids: string[];
}

export interface InternalAIAlgoTestsUpdateRequestV1 {
	/**
	 * @minLength 1
	 * @maxLength 50
	 */
	execution_id: string;
	/** @pattern ^sha256:[0-9a-f]{64}$ */
	expected_revision: string;
	allow_shared?: boolean;
	tests: InternalProblemTestsDocumentV1;
}

export interface InternalAIAlgoTestsUpdateResultV1 {
	/**
	 * @minLength 1
	 * @maxLength 50
	 */
	ai_problem_id: string;
	/**
	 * @minLength 1
	 * @maxLength 50
	 */
	execution_id: string;
	/** @pattern ^sha256:[0-9a-f]{64}$ */
	previous_revision: string;
	/** @pattern ^sha256:[0-9a-f]{64}$ */
	revision: string;
	/** @min 2 */
	tests_count: number;
	solutions_checked: false;
	shared: boolean;
	affected_problems: InternalAIAlgoTestsAffectedProblemV1[];
	affected_execution_ids: string[];
}

export interface InternalProblemTestsDocumentV1 {
	/** @minItems 2 */
	tests: Record<string, any>[];
	[key: string]: any;
}

export interface InternalProblemTestsSnapshotV1 {
	problem_id: string;
	/** @min 1 */
	version: number;
	/** @pattern ^sha256:[0-9a-f]{64}$ */
	fixture_revision: string;
	state: 'present' | 'missing';
	tests: Record<string, any>;
}

export interface InternalProblemTestsUpdateRequestV1 {
	/** @min 1 */
	expected_version: number;
	/** @pattern ^sha256:[0-9a-f]{64}$ */
	expected_fixture_revision: string;
	tests: InternalProblemTestsDocumentV1;
}

export interface InternalProblemTestsUpdateResultV1 {
	problem_id: string;
	/** @min 1 */
	version: number;
	/** @pattern ^sha256:[0-9a-f]{64}$ */
	previous_fixture_revision: string;
	/** @pattern ^sha256:[0-9a-f]{64}$ */
	fixture_revision: string;
	/** @min 2 */
	tests_count: number;
	solutions_checked: false;
}

export interface InternalProblemTemplateUpdateRequestV1 {
	/** @min 1 */
	expected_version: number;
	/** @pattern ^sha256:[0-9a-f]{64}$ */
	expected_fixture_revision: string;
	template: InternalProblemFunctionTemplateV1;
}

export interface InternalProblemTemplateUpdateResultV1 {
	problem_id: string;
	previous_version: number;
	version: number;
	fixture_revision: string;
	updated_language_ids: number[];
	solutions_checked: false;
}

export interface InternalProblemAuthoringErrorV1 {
	code: string;
	message: string;
	request_id?: string;
	current_version?: number;
	may_have_changed?: boolean;
	written_language_ids?: number[];
	field_errors?: {
		field: string;
		code: string;
	}[];
}

export interface InternalCompanyConflictV1 {
	id: string;
	name: string;
	matched_by: ('id' | 'name')[];
}

export interface InternalCompanyConflictResponseV1 {
	code: string;
	message: string;
	request_id: string;
	conflicts: InternalCompanyConflictV1[];
}

export interface InternalAIInterviewListResponseV1 {
	items: InternalAIInterviewSummaryV1[];
	offset: number;
	limit: number;
	total: number;
}

export interface InternalAIInterviewSummaryV1 {
	id: string;
	title: string;
	type: AIProblemTypeV1;
	summary: string;
	/** @min 0 */
	task_count: number;
	languages: number[];
	is_visible: boolean;
	is_free: boolean;
	course_usages: InternalAIInterviewCourseUsageV1[];
}

export interface InternalAIInterviewCourseUsageV1 {
	course_id: string;
	course_title: string;
}

export interface InternalAIDialogResultV1 {
	dialog_id: string;
	ai_problem_id: string;
	user_login: string;
	status: AIDialogStatusV1;
	/** @format date-time */
	created_at: string;
	messages: InternalAIDialogMessageV1[];
}

export interface InternalAIDialogMessageV1 {
	id: number;
	role: AIMessageRoleV1;
	content: string;
	/** @format date-time */
	created_at: string;
	attachments: InternalAIDialogAttachmentV1[];
}

export interface InternalAIDialogAttachmentV1 {
	file_name: string;
	content: string;
	file_format?: AIAttachmentFileFormatV1;
	problem_id?: string;
	helper_text?: string;
	config?: AIAttachmentSelectConfigV1;
}

export interface InternalAIInterviewCreateRequestV1 {
	type: AIProblemTypeV1;
	/**
	 * @minLength 1
	 * @maxLength 50000
	 */
	prompt: string;
}

export interface InternalAIProblemAuthoringGuideV1 {
	schema_version: string;
	guide_version: string;
	supported_problem_types: ('ai-theory' | 'ai-practice')[];
	policy: InternalAIProblemAuthoringGuidePolicyV1;
	global_rules: InternalAIProblemAuthoringGuideRuleV1[];
	problem_type_rules: Record<string, InternalAIProblemAuthoringGuideRuleV1[]>;
	profiles: Record<string, InternalAIProblemAuthoringGuideProfileV1>;
	limits: InternalAIProblemAuthoringGuideLimitsV1;
	examples: InternalAIProblemAuthoringGuideExampleV1[];
}

export interface InternalAIProblemAuthoringGuidePolicyV1 {
	default_mode: 'source_only';
	precedence: (
		| 'task_language_profile'
		| 'task_profile'
		| 'problem_type'
		| 'global'
	)[];
	user_permission_is_scoped: boolean;
}

export interface InternalAIProblemAuthoringGuideRuleV1 {
	id: string;
	instruction: string;
	when?: string[];
	constraints?: string[];
}

export interface InternalAIProblemAuthoringGuideSynthesisPermissionV1 {
	field: string;
	allowed: boolean;
	when: string[];
	constraints: string[];
}

export interface InternalAIProblemAuthoringGuideProfileV1 {
	problem_types: ('ai-theory' | 'ai-practice')[];
	task_type: 'static' | 'questions' | 'discussion' | 'code';
	language?: 'golang' | 'postgresql' | 'python' | 'java';
	rules: InternalAIProblemAuthoringGuideRuleV1[];
	synthesis_permissions: InternalAIProblemAuthoringGuideSynthesisPermissionV1[];
}

export interface InternalAIProblemAuthoringGuideLimitsV1 {
	max_tasks_per_problem: number;
	max_attachments_per_problem: number;
	max_content_characters: number;
	max_candidate_characters: number;
	max_batch_items: number;
	max_batch_characters: number;
}

export interface InternalAIProblemAuthoringGuideExampleV1 {
	id: string;
	profile: string;
	situation: string;
	expected_action: string;
}

export interface InternalAIProblemCreateCandidateV1 {
	schema_version: '1';
	/**
	 * @minLength 1
	 * @maxLength 1000
	 */
	client_ref: string;
	/**
	 * @minLength 1
	 * @maxLength 1000
	 */
	idempotency_key: string;
	problem: InternalAIProblemDraftV1;
	source_materials: InternalAIProblemSourceMaterialV1[];
	authoring: {
		guide_version: string;
	};
}

export interface InternalAIProblemDraftV1 {
	/** @minLength 1 */
	id_hint: string;
	/** @minLength 1 */
	title: string;
	type: 'ai-theory' | 'ai-practice';
	language?: 'golang' | 'postgresql' | 'python' | 'java';
	/**
	 * @maxItems 20
	 * @minItems 1
	 */
	tasks: InternalAIProblemTaskDraftV1[];
}

export interface InternalAIProblemTaskDraftV1 {
	type: 'static' | 'questions' | 'discussion' | 'code';
	/** @minItems 1 */
	source_refs: string[];
	initial_message: InternalAIProblemInitialMessageV1;
	/** Допустимые поля зависят от type шага и строго проверяются доменным validator. */
	config: InternalAIProblemTaskConfigV1;
}

export interface InternalAIProblemInitialMessageV1 {
	/** @minLength 1 */
	content: string;
	attachments: InternalAIProblemAttachmentV1[];
}

export interface InternalAIProblemInitialMessagePatchV1 {
	/** @minLength 1 */
	content?: string;
	attachments?: InternalAIProblemAttachmentV1[];
}

export interface InternalAIProblemAttachmentV1 {
	/** @minLength 1 */
	file_name: string;
	content: string;
	helper_text?: string;
}

/** Допустимые поля зависят от type шага и строго проверяются доменным validator. */
export interface InternalAIProblemTaskConfigV1 {
	questions?: {
		/** @minLength 1 */
		question: string;
		/** @minLength 1 */
		answer: string;
	}[];
	dod?: string[];
	commonHints?: string[];
	referenceSolutions?: string[];
	handlingType?: 'raw-execution';
}

export interface InternalAIProblemSourceMaterialV1 {
	/** @minLength 1 */
	ref: string;
	kind: 'file' | 'user_clarification' | 'user_permission';
	/** @minLength 1 */
	content: string;
}

export interface InternalAIProblemCreateEnvelopeV1 {
	candidate: InternalAIProblemCreateCandidateV1;
	/** @default "fail" */
	on_id_conflict?: 'fail' | 'use_suffix';
}

export interface InternalAIProblemValidationIssueV1 {
	severity: 'error' | 'warning';
	category:
		| 'schema'
		| 'domain'
		| 'material'
		| 'quality'
		| 'reference'
		| 'limit'
		| 'conflict';
	code: string;
	path: string;
	message: string;
	resolution:
		| 'agent_can_fix'
		| 'user_input_required'
		| 'unsupported'
		| 'retry_later';
}

export interface InternalAIProblemInputRequestV1 {
	path: string;
	message: string;
}

export interface InternalAIProblemCreateResultV1 {
	status:
		| 'created'
		| 'already_created'
		| 'invalid'
		| 'conflict'
		| 'failed'
		| 'not_created';
	client_ref: string;
	ai_problem_id?: string;
	retryable?: boolean;
	issues?: InternalAIProblemValidationIssueV1[];
}

export interface InternalAIProblemBatchCreateEnvelopeV1 {
	/** @maxItems 20 */
	items: InternalAIProblemCreateCandidateV1[];
	mode: 'all_valid' | 'valid_only';
	/** @default "fail" */
	on_id_conflict?: 'fail' | 'use_suffix';
}

export interface InternalAIProblemBatchCreateResultV1 {
	status: 'completed' | 'invalid';
	items: InternalAIProblemCreateResultV1[];
	summary: {
		created: number;
		already_created: number;
		invalid: number;
		conflict: number;
		failed: number;
		not_created: number;
	};
}

/** Command PATCH; команды шагов применяются атомарно. config рекурсивно объединяется с сохранённым объектом; массивы заменяются целиком, null удаляет поле. Непереданные поля сохраняются. */
export interface InternalAIProblemPatchV1 {
	/** @minLength 1 */
	title?: string;
	type?: 'ai-theory' | 'ai-practice' | 'ai-interview' | 'ai-algo';
	language?: 'golang' | 'postgresql' | 'python' | 'java' | '';
	/**
	 * Полный список языков; нельзя передавать одновременно с language.
	 * @uniqueItems true
	 */
	languages?: (
		| 'golang'
		| 'postgresql'
		| 'python'
		| 'java'
		| 'cpp'
		| 'javascript'
		| 'csharp'
	)[];
	/** Partial language map of complete report Markdown including code. Omitted languages are preserved; null deletes a language. No report without an attempt language or a nonblank matching reference. */
	reference_solution_by_language?: Record<string, string | null>;
	/** @min 0 */
	time_limit_minutes?: number;
	permission_level?: PermissionLevelV1;
	is_free?: boolean;
	is_visible?: boolean;
	self_review_enabled?: boolean;
	report_prompt?: string;
	/** Сериализованный JSON AIMessage с текстом или вложениями; пустая строка очищает сообщение. Обычный текст не допускается. */
	completion_message?: string;
	tasks?: InternalAIProblemTaskPatchCommandsV1;
}

export interface InternalAIProblemTaskPatchCommandsV1 {
	add?: InternalAIProblemAddTaskCommandV1[];
	update?: InternalAIProblemUpdateTaskCommandV1[];
	remove?: string[];
	/** Полный итоговый порядок; новые шаги допускается указывать по client_ref. */
	order?: string[];
}

export interface InternalAIProblemAddTaskCommandV1 {
	/** @minLength 1 */
	client_ref: string;
	type:
		| 'static'
		| 'questions'
		| 'discussion'
		| 'code'
		| 'select'
		| 'multi-select'
		| 'problem'
		| 'code-review';
	source_refs?: string[];
	initial_message: InternalAIProblemEditableInitialMessageV1;
	/** Поля зависят от типа этапа. В update объекты объединяются рекурсивно, массивы заменяются, null удаляет поле. В add передаётся полная конфигурация. */
	config: InternalAIProblemEditableTaskConfigV1;
}

export interface InternalAIProblemUpdateTaskCommandV1 {
	/** @minLength 1 */
	task_id: string;
	type?:
		| 'static'
		| 'questions'
		| 'discussion'
		| 'code'
		| 'select'
		| 'multi-select'
		| 'problem'
		| 'code-review';
	initial_message?: InternalAIProblemEditableInitialMessagePatchV1;
	/** Поля зависят от типа этапа. В update объекты объединяются рекурсивно, массивы заменяются, null удаляет поле. В add передаётся полная конфигурация. */
	config?: InternalAIProblemEditableTaskConfigV1;
}

export interface InternalAIProblemEditableAttachmentV1 {
	/** @minLength 1 */
	file_name: string;
	content: string;
	helper_text?: string;
	problem_id?: string;
	config?: Record<string, any>;
}

export interface InternalAIProblemEditableInitialMessageV1 {
	/** @minLength 1 */
	content: string;
	attachments?: InternalAIProblemEditableAttachmentV1[];
	byLanguage?: Record<string, InternalAIProblemMessageLanguagePatchV1>;
}

export interface InternalAIProblemEditableInitialMessagePatchV1 {
	/** @minLength 1 */
	content?: string;
	attachments?: InternalAIProblemEditableAttachmentV1[];
	/** Частичное обновление вариантов по языкам; null удаляет вариант. */
	byLanguage?: Record<string, InternalAIProblemMessageLanguagePatchV1>;
}

export type InternalAIProblemMessageLanguagePatchV1 = {
	content?: string;
	attachments?: InternalAIProblemEditableAttachmentV1[];
} | null;

export type InternalAIProblemTaskLanguagePatchV1 = {
	additionalDod?: string[] | null;
	additionalCommonHints?: string[] | null;
};

/** Поля зависят от типа этапа. В update объекты объединяются рекурсивно, массивы заменяются, null удаляет поле. В add передаётся полная конфигурация. */
export interface InternalAIProblemEditableTaskConfigV1 {
	title?: string | null;
	referenceSolution?: string | null;
	referenceMaterial?: string | null;
	problemId?: string | null;
	executionId?: string | null;
	handlingType?: string | null;
	correctOptionId?: string | null;
	dod?: string[] | null;
	commonHints?: string[] | null;
	commonMistakes?: string[] | null;
	referenceSolutions?: string[] | null;
	referenceSolutionByLanguage?: Record<string, string | null>;
	referenceSolutionsByLanguage?: Record<string, string[] | null>;
	byLanguage?: Record<string, InternalAIProblemTaskLanguagePatchV1>;
	questions?:
		| {
				/** @minLength 1 */
				question: string;
				/** @minLength 1 */
				answer: string;
		  }[]
		| null;
	options?:
		| {
				/** @minLength 1 */
				id: string;
				/** @minLength 1 */
				text: string;
		  }[]
		| null;
}

export interface InternalAIProblemPatchResultV1 {
	ai_problem_id: string;
	added_task_ids: Record<string, string>;
	issues: InternalAIProblemValidationIssueV1[];
}

export interface InvalidFeedbackInputV1 {
	message: 'invalid_input';
}

export interface FeedbackNotFoundV1 {
	message: 'feedback_not_found';
}

export interface FeedbackContextUnavailableV1 {
	message: 'feedback_context_unavailable';
}

export interface InternalFeedbackDialogV1 {
	/** @pattern ^[0-9A-F]{32}$ */
	feedback_id: string;
	/** @format date-time */
	feedback_created_at: string;
	/**
	 * @minLength 1
	 * @maxLength 50
	 */
	ai_problem_id: string;
	/** @pattern ^[0-9A-F]{32}$ */
	ai_dialog_id: string;
	/**
	 * @min 1
	 * @max 2147483647
	 */
	ai_message_id: number;
	user_login: string;
	status: AIDialogStatusV1;
	/** @format date-time */
	created_at: string;
	messages: InternalFeedbackDialogMessageV1[];
}

export interface InternalFeedbackDialogMessageV1 {
	/**
	 * @min 1
	 * @max 2147483647
	 */
	id: number;
	role: AIMessageRoleV1;
	content: string;
	/** @format date-time */
	created_at: string;
	is_feedback_target: boolean;
	attachments: InternalAIDialogAttachmentV1[];
}

export interface InternalFeedbackTargetV1 {
	type: FeedbackTargetEnumV1;
	id: string;
	title: string | null;
}

export interface InternalFeedbackRecordV1 {
	/** @pattern ^[0-9A-F]{32}$ */
	ai_dialog_id: string | null;
	/**
	 * @min 1
	 * @max 2147483647
	 */
	ai_message_id: number | null;
	/** @pattern ^[0-9A-F]{32}$ */
	id: string;
	target: InternalFeedbackTargetV1;
	/**
	 * @minLength 1
	 * @maxLength 50
	 */
	ai_problem_id: string | null;
	type: 'error' | 'improvement' | null;
	status: 'solved' | 'unsolved';
	title: string;
	message: string;
	user_login: string;
	/** @format date-time */
	created_at: string;
}

export interface InternalFeedbackListV1 {
	items: InternalFeedbackRecordV1[];
	/** @min 0 */
	total: number;
	/** @min 0 */
	offset: number;
	/**
	 * @min 1
	 * @max 100
	 */
	limit: number;
}

export interface InternalFeedbackResolveV1 {
	/** @pattern ^[0-9A-F]{32}$ */
	feedback_id: string;
	status: 'solved';
	changed: boolean;
}

export interface InternalErrorV1 {
	code: string;
	message: string;
	request_id: string;
	field_errors?: {
		field: string;
		code: string;
		message?: string;
	}[];
}

export interface InternalProblemFunctionTemplateV1 {
	/**
	 * @minLength 1
	 * @maxLength 64
	 * @pattern ^[a-z][a-z0-9_]*$
	 */
	function_name: string;
	/** @maxItems 32 */
	test_input_types: InternalProblemTemplateArgumentV1[];
	test_output_type: InternalProblemTemplateOutputV1;
}

export interface InternalAIAlgoCardFileV1 {
	/** @minLength 1 */
	file_name: string;
	content: string;
}

export interface InternalAIAlgoCardLanguageV1 {
	/** @min 1 */
	language_id: number;
	starter_source: 'codegen' | 'manual';
	starter_files: InternalAIAlgoCardFileV1[];
	solution_md: string;
}

export interface InternalAIAlgoCardV1 {
	tags?: ProblemTagV1[];
	/** @min 0 */
	tags_version?: number;
	ai_problem_id: string;
	revision: string;
	title: string;
	description_md: string;
	video_md: string;
	difficulty: number;
	company_ids: string[];
	is_visible: boolean;
	is_free: boolean;
	permission_level: 'public' | 'regular' | 'advanced';
	execution_id: string | null;
	languages: InternalAIAlgoCardLanguageV1[];
}

export interface InternalAIAlgoCardSolutionV1 {
	/** @min 1 */
	language_id: number;
	/** @minLength 1 */
	solution_md: string;
}

export interface InternalAIAlgoCardStarterV1 {
	/** @min 1 */
	language_id: number;
	files: InternalAIAlgoCardFileV1[];
}

export interface InternalAIAlgoCardPatchV1 {
	/**
	 * @minLength 1
	 * @maxLength 255
	 */
	title?: string;
	/**
	 * At most 65535 UTF-8 bytes.
	 * @minLength 1
	 */
	description_md?: string;
	/** At most 65535 UTF-8 bytes; empty clears video. */
	video_md?: string;
	difficulty?: 1 | 2 | 3;
	/**
	 * @maxItems 100
	 * @uniqueItems true
	 */
	company_ids?: string[];
	is_visible?: boolean;
	is_free?: boolean;
	permission_level?: 'public' | 'regular' | 'advanced';
	solutions?: InternalAIAlgoCardSolutionV1[];
	starters?: InternalAIAlgoCardStarterV1[];
}

export interface InternalAIAlgoCardUpdateRequestV1 {
	/** @pattern ^sha256:[0-9a-f]{64}$ */
	expected_revision: string;
	patch: InternalAIAlgoCardPatchV1;
}

export interface InternalAIAlgoCardUpdateResultV1 {
	ai_problem_id: string;
	previous_revision: string;
	revision: string;
	updated_fields: string[];
	solutions_checked: boolean;
}
